// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { allowsInterestPolicyList, androidCallback, bestContentsFeedback, calculateDonation, callback, callback1, callbackComplete, checkPlusSuccess, commonCodeInit, commonCodeInit1, complete, createApiCounsel, faqList, feedbackCommunityWelloNews, feedbackPointMarketProduct, fileDecryptionDownload, fileDelete, fileUpload, findAllInquiries, findArticle, findArticleFeedback, findBenefitLotteryPool, findBenefitMenuList, findBestContents, findBestContentsTagList, findChildHomeLoveGovCodeList, findDailyPickList, findDaouProductList, findDonationBusinesses, findFeaturedDonationBusinessList, findFeeds, findGeneralDownloadableCoupons, findGiftCategoryGroupList, findGiftCategoryGroupProductList, findGiftCategoryList, findGiftProductDetail, findGiftProductList, findGiftProducts, findGoodPointTypes, findHomeInstitutionList, findHomeInstitutionSpecialtyList, findHometownNews, findInquiry, findIntegrated, findLocalMarketProducts, findMonthlyThemes, findNonsanRoulette, findParentHomeLoveGovCodeList, findPhotoReviews, findPolicies, findPopularGiftProductList, findQueryAgeCode, findQueryJobCode, findQueryProvisionCode, findQueryTargetCode, findRecentGiftProductList, findRecommendGiftProduct, findRelatedGiftProductList, findReview, findReviews, findRootGiftCategoryList, findThemeArticles, findThemeFestivals, findTourDistance, findTourFeedback, findTourFestival, findTourFestivals, findTourLclsSystmCodeList, findTourReviews, findTrend, findWeeklyBestPhotoReviewList, getActiveMaintenanceList, getAdminHomeSearchKeywordList, getApiPolicyList, getApiPolicyNameList, getApiProductNameList, getApiTheme, getApiThemeKeywordNameList, getApiThemeList, getApiThemeNameList, getBestContents, getCommunityWelloNews, getCommunityWelloNewsList, getControlManagements, getDecemberEventGiftProductList, getDecemberInstitutionEventInfoList, getDecemberRandomTicketWinnerList, getDonationBusiness, getDonationBusinessCommentList, getDonationBusinessDetailCount, getDonationBusinessList, getEmergencyRoom, getEmergencyRoomCodeList, getEmergencyRoomList, getEmergencyRoomListCount, getEmergencyRoomLive, getEmergencyRoomRegionList, getEventAmountInfo, getGiftOrderProductPhotoReviewListByProduct, getGiftOrderProductReview, getGiftOrderProductReviewList, getGiftProductSeo, getGiftReviewFeed, getHomeDonationEvent, getHomeDonationHistoryByDonationBusinessList, getHomeDonationStatisticsList, getHomeInquiry, getHomeInquiryList, getHomeInstitution, getHomeInstitutionBenefitList, getHomeInstitutionBenefitListAll, getHomeInstitutionBenefitPrivateList, getHomeInstitutionBenefitPublicList, getHomeInstitutionBenefitRegionList, getHomeInstitutionContent, getHomeInstitutionContentList, getHomeInstitutionDonationBusiness, getHomeInstitutionEvent, getHomeInstitutionEventList, getHomeInstitutionListForSearchFilter, getHomeInstitutionPolicyList, getHomeLoveGovCodeToId, getHomeNotice, getHomeNoticeList, getHomePopupNotice, getInstitutionGiftProductList, getInstitutionRelatedDonationBusiness, getInstitutionSpecialtyList, getKbMemberLoginTypeList, getKbMemberLoginTypeList1, getListPolicyCaseCategory, getLiveWelloCommentList, getMaintenance, getMedianIncomeList, getMemberNameByInviteCode, getMetaPolicyCommentList, getMetaPolicyCommentList1, getNonMemberSuggestPolicyList, getOrderedHomeInstitutionEventList, getPointMarketProduct, getPointMarketProductList, getPointMarketProductListByBrand, getPolicyCodeGeocodingList, getPolicyDictionaryList, getProductDetail, getProductDetailByProductNumber, getProductFeedList, getProductSeo, getProductSeoByProductId, getRecentEventHistoryList, getRecentEventHistoryListInSeptember, getRecentOpenedGiftBoxList, getRelatedDonationBusiness, getRelatedHometownNewsList, getTopDonationEventHistoryList, getTopInviterListInAugust, getUrlMapping, getWelloQuickMenuList, handleAuthResult, handleNicePayWebhook, hometownNews, hometownNewsFeedback, init, integrate, iosCallback, isEventInProgress, joinEvent, kbWelloPolicyCodeAllList, loginWelloSnsMember, loginWelloSnsMember1, loginWelloWithKbPay, loginWelloWithKbPay1, messageReceive, metaCodeAll, metaPolicy, metaPolicyFeedback, newWelloAppPushCnt, notice, noticeList, noticeList1, type Options, popularPolicyList, rejectMessage, resignExternalChannelMember, resignMembers, resignWelloWithKbPay, reverseGeocoding, saveAllowsWelloDeviceInfo, saveNicknameConsent, saveWelloNonmemberRegion, saveWelloTracking, sendAppPush, sendExtAppPush, snsRefreshToken, snsRefreshToken1, term, termHistory, updateFileTempSaveYn, updateMessageReceive, updatePolicyAiInfo, updateWelloAppPushRead, updateWelloAppPushRead1, verify, viewHomeGiftProduct, welloAppPushList, welloBeforeLogin, welloPolicyCodeAllList, welloPolicyCodeBabyList, welloPolicyCodeList } from '../sdk.gen';
import type { AllowsInterestPolicyListData, AllowsInterestPolicyListError, AllowsInterestPolicyListResponse, AndroidCallbackData, AndroidCallbackError, AndroidCallbackResponse, BestContentsFeedbackData, BestContentsFeedbackError, BestContentsFeedbackResponse, CalculateDonationData, CalculateDonationError, CalculateDonationResponse, Callback1Data, Callback1Error, Callback1Response, CallbackCompleteData, CallbackCompleteError, CallbackData, CallbackError, CallbackResponse, CheckPlusSuccessData, CheckPlusSuccessError, CheckPlusSuccessResponse, CommonCodeInit1Data, CommonCodeInit1Error, CommonCodeInit1Response, CommonCodeInitData, CommonCodeInitError, CommonCodeInitResponse, CompleteData, CompleteError, CompleteResponse, CreateApiCounselData, CreateApiCounselError, CreateApiCounselResponse, FaqListData, FaqListError, FaqListResponse, FeedbackCommunityWelloNewsData, FeedbackCommunityWelloNewsError, FeedbackCommunityWelloNewsResponse, FeedbackPointMarketProductData, FeedbackPointMarketProductError, FeedbackPointMarketProductResponse, FileDecryptionDownloadData, FileDecryptionDownloadError, FileDecryptionDownloadResponse, FileDeleteData, FileDeleteError, FileDeleteResponse, FileUploadData, FileUploadError, FileUploadResponse, FindAllInquiriesData, FindAllInquiriesError, FindAllInquiriesResponse, FindArticleData, FindArticleError, FindArticleFeedbackData, FindArticleFeedbackError, FindArticleFeedbackResponse, FindArticleResponse, FindBenefitLotteryPoolData, FindBenefitLotteryPoolError, FindBenefitLotteryPoolResponse, FindBenefitMenuListData, FindBenefitMenuListError, FindBenefitMenuListResponse, FindBestContentsData, FindBestContentsError, FindBestContentsResponse, FindBestContentsTagListData, FindBestContentsTagListError, FindBestContentsTagListResponse, FindChildHomeLoveGovCodeListData, FindChildHomeLoveGovCodeListError, FindChildHomeLoveGovCodeListResponse, FindDailyPickListData, FindDailyPickListError, FindDailyPickListResponse, FindDaouProductListData, FindDaouProductListError, FindDaouProductListResponse, FindDonationBusinessesData, FindDonationBusinessesError, FindDonationBusinessesResponse, FindFeaturedDonationBusinessListData, FindFeaturedDonationBusinessListError, FindFeaturedDonationBusinessListResponse, FindFeedsData, FindFeedsError, FindFeedsResponse, FindGeneralDownloadableCouponsData, FindGeneralDownloadableCouponsError, FindGeneralDownloadableCouponsResponse, FindGiftCategoryGroupListData, FindGiftCategoryGroupListError, FindGiftCategoryGroupListResponse, FindGiftCategoryGroupProductListData, FindGiftCategoryGroupProductListError, FindGiftCategoryGroupProductListResponse, FindGiftCategoryListData, FindGiftCategoryListError, FindGiftCategoryListResponse, FindGiftProductDetailData, FindGiftProductDetailError, FindGiftProductDetailResponse, FindGiftProductListData, FindGiftProductListError, FindGiftProductListResponse, FindGiftProductsData, FindGiftProductsError, FindGiftProductsResponse, FindGoodPointTypesData, FindGoodPointTypesError, FindGoodPointTypesResponse, FindHomeInstitutionListData, FindHomeInstitutionListError, FindHomeInstitutionListResponse, FindHomeInstitutionSpecialtyListData, FindHomeInstitutionSpecialtyListError, FindHomeInstitutionSpecialtyListResponse, FindHometownNewsData, FindHometownNewsError, FindHometownNewsResponse, FindInquiryData, FindInquiryError, FindInquiryResponse, FindIntegratedData, FindIntegratedError, FindIntegratedResponse, FindLocalMarketProductsData, FindLocalMarketProductsError, FindLocalMarketProductsResponse, FindMonthlyThemesData, FindMonthlyThemesError, FindMonthlyThemesResponse, FindNonsanRouletteData, FindNonsanRouletteError, FindNonsanRouletteResponse, FindParentHomeLoveGovCodeListData, FindParentHomeLoveGovCodeListError, FindParentHomeLoveGovCodeListResponse, FindPhotoReviewsData, FindPhotoReviewsError, FindPhotoReviewsResponse, FindPoliciesData, FindPoliciesError, FindPoliciesResponse, FindPopularGiftProductListData, FindPopularGiftProductListError, FindPopularGiftProductListResponse, FindQueryAgeCodeData, FindQueryAgeCodeError, FindQueryAgeCodeResponse, FindQueryJobCodeData, FindQueryJobCodeError, FindQueryJobCodeResponse, FindQueryProvisionCodeData, FindQueryProvisionCodeError, FindQueryProvisionCodeResponse, FindQueryTargetCodeData, FindQueryTargetCodeError, FindQueryTargetCodeResponse, FindRecentGiftProductListData, FindRecentGiftProductListError, FindRecentGiftProductListResponse, FindRecommendGiftProductData, FindRecommendGiftProductError, FindRecommendGiftProductResponse, FindRelatedGiftProductListData, FindRelatedGiftProductListError, FindRelatedGiftProductListResponse, FindReviewData, FindReviewError, FindReviewResponse, FindReviewsData, FindReviewsError, FindReviewsResponse, FindRootGiftCategoryListData, FindRootGiftCategoryListError, FindRootGiftCategoryListResponse, FindThemeArticlesData, FindThemeArticlesError, FindThemeArticlesResponse, FindThemeFestivalsData, FindThemeFestivalsError, FindThemeFestivalsResponse, FindTourDistanceData, FindTourDistanceError, FindTourDistanceResponse, FindTourFeedbackData, FindTourFeedbackError, FindTourFeedbackResponse, FindTourFestivalData, FindTourFestivalError, FindTourFestivalResponse, FindTourFestivalsData, FindTourFestivalsError, FindTourFestivalsResponse, FindTourLclsSystmCodeListData, FindTourLclsSystmCodeListError, FindTourLclsSystmCodeListResponse, FindTourReviewsData, FindTourReviewsError, FindTourReviewsResponse, FindTrendData, FindTrendError, FindTrendResponse, FindWeeklyBestPhotoReviewListData, FindWeeklyBestPhotoReviewListError, FindWeeklyBestPhotoReviewListResponse, GetActiveMaintenanceListData, GetActiveMaintenanceListError, GetActiveMaintenanceListResponse, GetAdminHomeSearchKeywordListData, GetAdminHomeSearchKeywordListError, GetAdminHomeSearchKeywordListResponse, GetApiPolicyListData, GetApiPolicyListError, GetApiPolicyListResponse, GetApiPolicyNameListData, GetApiPolicyNameListError, GetApiPolicyNameListResponse, GetApiProductNameListData, GetApiProductNameListError, GetApiProductNameListResponse, GetApiThemeData, GetApiThemeError, GetApiThemeKeywordNameListData, GetApiThemeKeywordNameListError, GetApiThemeKeywordNameListResponse, GetApiThemeListData, GetApiThemeListError, GetApiThemeListResponse, GetApiThemeNameListData, GetApiThemeNameListError, GetApiThemeNameListResponse, GetApiThemeResponse, GetBestContentsData, GetBestContentsError, GetBestContentsResponse, GetCommunityWelloNewsData, GetCommunityWelloNewsError, GetCommunityWelloNewsListData, GetCommunityWelloNewsListError, GetCommunityWelloNewsListResponse, GetCommunityWelloNewsResponse, GetControlManagementsData, GetControlManagementsError, GetControlManagementsResponse, GetDecemberEventGiftProductListData, GetDecemberEventGiftProductListError, GetDecemberEventGiftProductListResponse, GetDecemberInstitutionEventInfoListData, GetDecemberInstitutionEventInfoListError, GetDecemberInstitutionEventInfoListResponse, GetDecemberRandomTicketWinnerListData, GetDecemberRandomTicketWinnerListError, GetDecemberRandomTicketWinnerListResponse, GetDonationBusinessCommentListData, GetDonationBusinessCommentListError, GetDonationBusinessCommentListResponse, GetDonationBusinessData, GetDonationBusinessDetailCountData, GetDonationBusinessDetailCountError, GetDonationBusinessDetailCountResponse, GetDonationBusinessError, GetDonationBusinessListData, GetDonationBusinessListError, GetDonationBusinessListResponse, GetDonationBusinessResponse, GetEmergencyRoomCodeListData, GetEmergencyRoomCodeListError, GetEmergencyRoomCodeListResponse, GetEmergencyRoomData, GetEmergencyRoomError, GetEmergencyRoomListCountData, GetEmergencyRoomListCountError, GetEmergencyRoomListCountResponse, GetEmergencyRoomListData, GetEmergencyRoomListError, GetEmergencyRoomListResponse, GetEmergencyRoomLiveData, GetEmergencyRoomLiveError, GetEmergencyRoomLiveResponse, GetEmergencyRoomRegionListData, GetEmergencyRoomRegionListError, GetEmergencyRoomRegionListResponse, GetEmergencyRoomResponse, GetEventAmountInfoData, GetEventAmountInfoError, GetEventAmountInfoResponse, GetGiftOrderProductPhotoReviewListByProductData, GetGiftOrderProductPhotoReviewListByProductError, GetGiftOrderProductPhotoReviewListByProductResponse, GetGiftOrderProductReviewData, GetGiftOrderProductReviewError, GetGiftOrderProductReviewListData, GetGiftOrderProductReviewListError, GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewResponse, GetGiftProductSeoData, GetGiftProductSeoError, GetGiftProductSeoResponse, GetGiftReviewFeedData, GetGiftReviewFeedError, GetGiftReviewFeedResponse, GetHomeDonationEventData, GetHomeDonationEventError, GetHomeDonationEventResponse, GetHomeDonationHistoryByDonationBusinessListData, GetHomeDonationHistoryByDonationBusinessListError, GetHomeDonationHistoryByDonationBusinessListResponse, GetHomeDonationStatisticsListData, GetHomeDonationStatisticsListError, GetHomeDonationStatisticsListResponse, GetHomeInquiryData, GetHomeInquiryError, GetHomeInquiryListData, GetHomeInquiryListError, GetHomeInquiryListResponse, GetHomeInquiryResponse, GetHomeInstitutionBenefitListAllData, GetHomeInstitutionBenefitListAllError, GetHomeInstitutionBenefitListAllResponse, GetHomeInstitutionBenefitListData, GetHomeInstitutionBenefitListError, GetHomeInstitutionBenefitListResponse, GetHomeInstitutionBenefitPrivateListData, GetHomeInstitutionBenefitPrivateListError, GetHomeInstitutionBenefitPrivateListResponse, GetHomeInstitutionBenefitPublicListData, GetHomeInstitutionBenefitPublicListError, GetHomeInstitutionBenefitPublicListResponse, GetHomeInstitutionBenefitRegionListData, GetHomeInstitutionBenefitRegionListError, GetHomeInstitutionBenefitRegionListResponse, GetHomeInstitutionContentData, GetHomeInstitutionContentError, GetHomeInstitutionContentListData, GetHomeInstitutionContentListError, GetHomeInstitutionContentListResponse, GetHomeInstitutionContentResponse, GetHomeInstitutionData, GetHomeInstitutionDonationBusinessData, GetHomeInstitutionDonationBusinessError, GetHomeInstitutionDonationBusinessResponse, GetHomeInstitutionError, GetHomeInstitutionEventData, GetHomeInstitutionEventError, GetHomeInstitutionEventListData, GetHomeInstitutionEventListError, GetHomeInstitutionEventListResponse, GetHomeInstitutionEventResponse, GetHomeInstitutionListForSearchFilterData, GetHomeInstitutionListForSearchFilterError, GetHomeInstitutionListForSearchFilterResponse, GetHomeInstitutionPolicyListData, GetHomeInstitutionPolicyListError, GetHomeInstitutionPolicyListResponse, GetHomeInstitutionResponse, GetHomeLoveGovCodeToIdData, GetHomeLoveGovCodeToIdError, GetHomeLoveGovCodeToIdResponse, GetHomeNoticeData, GetHomeNoticeError, GetHomeNoticeListData, GetHomeNoticeListError, GetHomeNoticeListResponse, GetHomeNoticeResponse, GetHomePopupNoticeData, GetHomePopupNoticeError, GetHomePopupNoticeResponse, GetInstitutionGiftProductListData, GetInstitutionGiftProductListError, GetInstitutionGiftProductListResponse, GetInstitutionRelatedDonationBusinessData, GetInstitutionRelatedDonationBusinessError, GetInstitutionRelatedDonationBusinessResponse, GetInstitutionSpecialtyListData, GetInstitutionSpecialtyListError, GetInstitutionSpecialtyListResponse, GetKbMemberLoginTypeList1Data, GetKbMemberLoginTypeList1Error, GetKbMemberLoginTypeList1Response, GetKbMemberLoginTypeListData, GetKbMemberLoginTypeListError, GetKbMemberLoginTypeListResponse, GetListPolicyCaseCategoryData, GetListPolicyCaseCategoryError, GetListPolicyCaseCategoryResponse, GetLiveWelloCommentListData, GetLiveWelloCommentListError, GetLiveWelloCommentListResponse, GetMaintenanceData, GetMaintenanceError, GetMaintenanceResponse, GetMedianIncomeListData, GetMedianIncomeListError, GetMedianIncomeListResponse, GetMemberNameByInviteCodeData, GetMemberNameByInviteCodeError, GetMemberNameByInviteCodeResponse, GetMetaPolicyCommentList1Data, GetMetaPolicyCommentList1Error, GetMetaPolicyCommentList1Response, GetMetaPolicyCommentListData, GetMetaPolicyCommentListError, GetMetaPolicyCommentListResponse, GetNonMemberSuggestPolicyListData, GetNonMemberSuggestPolicyListError, GetNonMemberSuggestPolicyListResponse, GetOrderedHomeInstitutionEventListData, GetOrderedHomeInstitutionEventListError, GetOrderedHomeInstitutionEventListResponse, GetPointMarketProductData, GetPointMarketProductError, GetPointMarketProductListByBrandData, GetPointMarketProductListByBrandError, GetPointMarketProductListByBrandResponse, GetPointMarketProductListData, GetPointMarketProductListError, GetPointMarketProductListResponse, GetPointMarketProductResponse, GetPolicyCodeGeocodingListData, GetPolicyCodeGeocodingListError, GetPolicyCodeGeocodingListResponse, GetPolicyDictionaryListData, GetPolicyDictionaryListError, GetPolicyDictionaryListResponse, GetProductDetailByProductNumberData, GetProductDetailByProductNumberError, GetProductDetailByProductNumberResponse, GetProductDetailData, GetProductDetailError, GetProductDetailResponse, GetProductFeedListData, GetProductFeedListError, GetProductFeedListResponse, GetProductSeoByProductIdData, GetProductSeoByProductIdError, GetProductSeoByProductIdResponse, GetProductSeoData, GetProductSeoError, GetProductSeoResponse, GetRecentEventHistoryListData, GetRecentEventHistoryListError, GetRecentEventHistoryListInSeptemberData, GetRecentEventHistoryListInSeptemberError, GetRecentEventHistoryListInSeptemberResponse, GetRecentEventHistoryListResponse, GetRecentOpenedGiftBoxListData, GetRecentOpenedGiftBoxListError, GetRecentOpenedGiftBoxListResponse, GetRelatedDonationBusinessData, GetRelatedDonationBusinessError, GetRelatedDonationBusinessResponse, GetRelatedHometownNewsListData, GetRelatedHometownNewsListError, GetRelatedHometownNewsListResponse, GetTopDonationEventHistoryListData, GetTopDonationEventHistoryListError, GetTopDonationEventHistoryListResponse, GetTopInviterListInAugustData, GetTopInviterListInAugustError, GetTopInviterListInAugustResponse, GetUrlMappingData, GetUrlMappingError, GetUrlMappingResponse, GetWelloQuickMenuListData, GetWelloQuickMenuListError, GetWelloQuickMenuListResponse, HandleAuthResultData, HandleAuthResultError, HandleNicePayWebhookData, HandleNicePayWebhookError, HandleNicePayWebhookResponse, HometownNewsData, HometownNewsError, HometownNewsFeedbackData, HometownNewsFeedbackError, HometownNewsFeedbackResponse, HometownNewsResponse, InitData, InitError, InitResponse, IntegrateData, IntegrateError, IntegrateResponse, IosCallbackData, IosCallbackError, IosCallbackResponse, IsEventInProgressData, IsEventInProgressError, IsEventInProgressResponse, JoinEventData, JoinEventError, JoinEventResponse, KbWelloPolicyCodeAllListData, KbWelloPolicyCodeAllListError, KbWelloPolicyCodeAllListResponse, LoginWelloSnsMember1Data, LoginWelloSnsMember1Error, LoginWelloSnsMember1Response, LoginWelloSnsMemberData, LoginWelloSnsMemberError, LoginWelloSnsMemberResponse, LoginWelloWithKbPay1Data, LoginWelloWithKbPay1Error, LoginWelloWithKbPay1Response, LoginWelloWithKbPayData, LoginWelloWithKbPayError, LoginWelloWithKbPayResponse, MessageReceiveData, MessageReceiveError, MessageReceiveResponse, MetaCodeAllData, MetaCodeAllError, MetaCodeAllResponse2, MetaPolicyData, MetaPolicyError, MetaPolicyFeedbackData, MetaPolicyFeedbackError, MetaPolicyFeedbackResponse, MetaPolicyResponse, NewWelloAppPushCntData, NewWelloAppPushCntError, NewWelloAppPushCntResponse, NoticeData, NoticeError, NoticeList1Data, NoticeList1Error, NoticeList1Response, NoticeListData, NoticeListError, NoticeListResponse, NoticeResponse, PopularPolicyListData, PopularPolicyListError, PopularPolicyListResponse, RejectMessageData, RejectMessageError, RejectMessageResponse, ResignExternalChannelMemberData, ResignExternalChannelMemberError, ResignExternalChannelMemberResponse, ResignMembersData, ResignMembersError, ResignMembersResponse, ResignWelloWithKbPayData, ResignWelloWithKbPayError, ResignWelloWithKbPayResponse, ReverseGeocodingData, ReverseGeocodingError, ReverseGeocodingResponse2, SaveAllowsWelloDeviceInfoData, SaveAllowsWelloDeviceInfoError, SaveAllowsWelloDeviceInfoResponse, SaveNicknameConsentData, SaveNicknameConsentError, SaveNicknameConsentResponse, SaveWelloNonmemberRegionData, SaveWelloNonmemberRegionError, SaveWelloNonmemberRegionResponse, SaveWelloTrackingData, SaveWelloTrackingError, SaveWelloTrackingResponse, SendAppPushData, SendAppPushError, SendAppPushResponse, SendExtAppPushData, SendExtAppPushError, SendExtAppPushResponse, SnsRefreshToken1Data, SnsRefreshToken1Error, SnsRefreshToken1Response, SnsRefreshTokenData, SnsRefreshTokenError, SnsRefreshTokenResponse, TermData, TermError, TermHistoryData, TermHistoryError, TermHistoryResponse, TermResponse, UpdateFileTempSaveYnData, UpdateFileTempSaveYnError, UpdateFileTempSaveYnResponse, UpdateMessageReceiveData, UpdateMessageReceiveError, UpdateMessageReceiveResponse, UpdatePolicyAiInfoData, UpdatePolicyAiInfoError, UpdatePolicyAiInfoResponse, UpdateWelloAppPushRead1Data, UpdateWelloAppPushRead1Error, UpdateWelloAppPushRead1Response, UpdateWelloAppPushReadData, UpdateWelloAppPushReadError, UpdateWelloAppPushReadResponse, VerifyData, VerifyError, VerifyResponse, ViewHomeGiftProductData, ViewHomeGiftProductError, ViewHomeGiftProductResponse, WelloAppPushListData, WelloAppPushListError, WelloAppPushListResponse, WelloBeforeLoginData, WelloBeforeLoginError, WelloBeforeLoginResponse, WelloPolicyCodeAllListData, WelloPolicyCodeAllListError, WelloPolicyCodeAllListResponse, WelloPolicyCodeBabyListData, WelloPolicyCodeBabyListError, WelloPolicyCodeBabyListResponse, WelloPolicyCodeListData, WelloPolicyCodeListError, WelloPolicyCodeListResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const findMonthlyThemesQueryKey = (options: Options<FindMonthlyThemesData>) => createQueryKey('findMonthlyThemes', options);

/**
 * 월별 테마 큐레이션 조회
 *
 * 전달받은 날짜의 월에 해당하는 테마 목록과 이전달/다음달 테마 존재 여부를 반환한다.
 */
export const findMonthlyThemesOptions = (options: Options<FindMonthlyThemesData>) => queryOptions<FindMonthlyThemesResponse, FindMonthlyThemesError, FindMonthlyThemesResponse, ReturnType<typeof findMonthlyThemesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findMonthlyThemes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findMonthlyThemesQueryKey(options)
});

export const findThemeArticlesQueryKey = (options: Options<FindThemeArticlesData>) => createQueryKey('findThemeArticles', options);

/**
 * 테마별 Article 목록
 *
 * 선택된 테마에 매핑된 Article 카드 목록 (페이지네이션).
 */
export const findThemeArticlesOptions = (options: Options<FindThemeArticlesData>) => queryOptions<FindThemeArticlesResponse, FindThemeArticlesError, FindThemeArticlesResponse, ReturnType<typeof findThemeArticlesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findThemeArticles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findThemeArticlesQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const findThemeArticlesInfiniteQueryKey = (options: Options<FindThemeArticlesData>): QueryKey<Options<FindThemeArticlesData>> => createQueryKey('findThemeArticles', options, true);

/**
 * 테마별 Article 목록
 *
 * 선택된 테마에 매핑된 Article 카드 목록 (페이지네이션).
 */
export const findThemeArticlesInfiniteOptions = (options: Options<FindThemeArticlesData>) => {
    const opts = infiniteQueryOptions<FindThemeArticlesResponse, FindThemeArticlesError, InfiniteData<FindThemeArticlesResponse>, QueryKey<Options<FindThemeArticlesData>>, number | Pick<QueryKey<Options<FindThemeArticlesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindThemeArticlesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findThemeArticles({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findThemeArticlesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findThemeFestivalsQueryKey = (options: Options<FindThemeFestivalsData>) => createQueryKey('findThemeFestivals', options);

/**
 * 테마별 축제 목록
 *
 * 선택된 테마에 매핑된 TourFestival 카드 목록. subRegionCode 좌표 기준 거리(distance, 미터)를 포함하며, 진행중→예정→미정→종료 순 + 현재 월에 걸치는 축제 우선 + 거리 ASC로 정렬한다. status enum 포함 (페이지네이션).
 */
export const findThemeFestivalsOptions = (options: Options<FindThemeFestivalsData>) => queryOptions<FindThemeFestivalsResponse, FindThemeFestivalsError, FindThemeFestivalsResponse, ReturnType<typeof findThemeFestivalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findThemeFestivals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findThemeFestivalsQueryKey(options)
});

export const findThemeFestivalsInfiniteQueryKey = (options: Options<FindThemeFestivalsData>): QueryKey<Options<FindThemeFestivalsData>> => createQueryKey('findThemeFestivals', options, true);

/**
 * 테마별 축제 목록
 *
 * 선택된 테마에 매핑된 TourFestival 카드 목록. subRegionCode 좌표 기준 거리(distance, 미터)를 포함하며, 진행중→예정→미정→종료 순 + 현재 월에 걸치는 축제 우선 + 거리 ASC로 정렬한다. status enum 포함 (페이지네이션).
 */
export const findThemeFestivalsInfiniteOptions = (options: Options<FindThemeFestivalsData>) => {
    const opts = infiniteQueryOptions<FindThemeFestivalsResponse, FindThemeFestivalsError, InfiniteData<FindThemeFestivalsResponse>, QueryKey<Options<FindThemeFestivalsData>>, number | Pick<QueryKey<Options<FindThemeFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindThemeFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findThemeFestivals({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findThemeFestivalsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findArticleQueryKey = (options: Options<FindArticleData>) => createQueryKey('findArticle', options);

/**
 * 아티클 상세
 *
 * 아티클 상세 정보와 매핑된 테마 목록을 조회한다.
 */
export const findArticleOptions = (options: Options<FindArticleData>) => queryOptions<FindArticleResponse, FindArticleError, FindArticleResponse, ReturnType<typeof findArticleQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findArticle({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findArticleQueryKey(options)
});

export const findArticleFeedbackQueryKey = (options: Options<FindArticleFeedbackData>) => createQueryKey('findArticleFeedback', options);

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * 아티클 의 조회수 정보를 조회한다.
 */
export const findArticleFeedbackOptions = (options: Options<FindArticleFeedbackData>) => queryOptions<FindArticleFeedbackResponse, FindArticleFeedbackError, FindArticleFeedbackResponse, ReturnType<typeof findArticleFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findArticleFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findArticleFeedbackQueryKey(options)
});

export const findTourFestivalQueryKey = (options: Options<FindTourFestivalData>) => createQueryKey('findTourFestival', options);

/**
 * 축제 상세
 *
 * 축제 ID 로 상세 정보를 조회한다. 이미지, 반복정보, 프로그램, 테마 목록을 포함한다.
 */
export const findTourFestivalOptions = (options: Options<FindTourFestivalData>) => queryOptions<FindTourFestivalResponse, FindTourFestivalError, FindTourFestivalResponse, ReturnType<typeof findTourFestivalQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourFestival({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourFestivalQueryKey(options)
});

export const findTourReviewsQueryKey = (options: Options<FindTourReviewsData>) => createQueryKey('findTourReviews', options);

/**
 * 축제 리뷰 목록 조회
 *
 * 공개(deleteYN=false AND displayYN=true) 리뷰만 createAt DESC로 페이지 반환
 */
export const findTourReviewsOptions = (options: Options<FindTourReviewsData>) => queryOptions<FindTourReviewsResponse, FindTourReviewsError, FindTourReviewsResponse, ReturnType<typeof findTourReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourReviewsQueryKey(options)
});

export const findTourReviewsInfiniteQueryKey = (options: Options<FindTourReviewsData>): QueryKey<Options<FindTourReviewsData>> => createQueryKey('findTourReviews', options, true);

/**
 * 축제 리뷰 목록 조회
 *
 * 공개(deleteYN=false AND displayYN=true) 리뷰만 createAt DESC로 페이지 반환
 */
export const findTourReviewsInfiniteOptions = (options: Options<FindTourReviewsData>) => {
    const opts = infiniteQueryOptions<FindTourReviewsResponse, FindTourReviewsError, InfiniteData<FindTourReviewsResponse>, QueryKey<Options<FindTourReviewsData>>, number | Pick<QueryKey<Options<FindTourReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindTourReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findTourReviews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findTourReviewsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findTourLclsSystmCodeListQueryKey = (options?: Options<FindTourLclsSystmCodeListData>) => createQueryKey('findTourLclsSystmCodeList', options);

/**
 * 분류체계 코드 목록
 *
 * rootCode / parentCode / depth 를 optional AND 필터로 적용하여 분류체계 코드 목록을 조회합니다. 페이징 없음, sort ASC 정렬.
 */
export const findTourLclsSystmCodeListOptions = (options?: Options<FindTourLclsSystmCodeListData>) => queryOptions<FindTourLclsSystmCodeListResponse, FindTourLclsSystmCodeListError, FindTourLclsSystmCodeListResponse, ReturnType<typeof findTourLclsSystmCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourLclsSystmCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourLclsSystmCodeListQueryKey(options)
});

export const findGoodPointTypesQueryKey = (options?: Options<FindGoodPointTypesData>) => createQueryKey('findGoodPointTypes', options);

/**
 * 좋았어요 항목 타입 목록 조회
 *
 * 투어 리뷰 작성/수정 시 사용 가능한 좋았어요 항목 타입(name, desc) 목록을 조회합니다.
 */
export const findGoodPointTypesOptions = (options?: Options<FindGoodPointTypesData>) => queryOptions<FindGoodPointTypesResponse, FindGoodPointTypesError, FindGoodPointTypesResponse, ReturnType<typeof findGoodPointTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGoodPointTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGoodPointTypesQueryKey(options)
});

/**
 * API 도입 문의 작성
 */
export const createApiCounselMutation = (options?: Partial<Options<CreateApiCounselData>>): UseMutationOptions<CreateApiCounselResponse, CreateApiCounselError, Options<CreateApiCounselData>> => {
    const mutationOptions: UseMutationOptions<CreateApiCounselResponse, CreateApiCounselError, Options<CreateApiCounselData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApiCounsel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiPolicyListQueryKey = (options: Options<GetApiPolicyListData>) => createQueryKey('getApiPolicyList', options);

/**
 * API 개별 상품 목록 조회
 */
export const getApiPolicyListOptions = (options: Options<GetApiPolicyListData>) => queryOptions<GetApiPolicyListResponse, GetApiPolicyListError, GetApiPolicyListResponse, ReturnType<typeof getApiPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPolicyListQueryKey(options)
});

export const getApiPolicyListInfiniteQueryKey = (options: Options<GetApiPolicyListData>): QueryKey<Options<GetApiPolicyListData>> => createQueryKey('getApiPolicyList', options, true);

/**
 * API 개별 상품 목록 조회
 */
export const getApiPolicyListInfiniteOptions = (options: Options<GetApiPolicyListData>) => {
    const opts = infiniteQueryOptions<GetApiPolicyListResponse, GetApiPolicyListError, InfiniteData<GetApiPolicyListResponse>, QueryKey<Options<GetApiPolicyListData>>, number | Pick<QueryKey<Options<GetApiPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiPolicyList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiPolicyListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiPolicyNameListQueryKey = (options: Options<GetApiPolicyNameListData>) => createQueryKey('getApiPolicyNameList', options);

/**
 * API 개별 상품명 검색
 */
export const getApiPolicyNameListOptions = (options: Options<GetApiPolicyNameListData>) => queryOptions<GetApiPolicyNameListResponse, GetApiPolicyNameListError, GetApiPolicyNameListResponse, ReturnType<typeof getApiPolicyNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiPolicyNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiPolicyNameListQueryKey(options)
});

export const getApiPolicyNameListInfiniteQueryKey = (options: Options<GetApiPolicyNameListData>): QueryKey<Options<GetApiPolicyNameListData>> => createQueryKey('getApiPolicyNameList', options, true);

/**
 * API 개별 상품명 검색
 */
export const getApiPolicyNameListInfiniteOptions = (options: Options<GetApiPolicyNameListData>) => {
    const opts = infiniteQueryOptions<GetApiPolicyNameListResponse, GetApiPolicyNameListError, InfiniteData<GetApiPolicyNameListResponse>, QueryKey<Options<GetApiPolicyNameListData>>, number | Pick<QueryKey<Options<GetApiPolicyNameListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiPolicyNameListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiPolicyNameList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiPolicyNameListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiProductNameListQueryKey = (options: Options<GetApiProductNameListData>) => createQueryKey('getApiProductNameList', options);

/**
 * API 상품명 검색
 */
export const getApiProductNameListOptions = (options: Options<GetApiProductNameListData>) => queryOptions<GetApiProductNameListResponse, GetApiProductNameListError, GetApiProductNameListResponse, ReturnType<typeof getApiProductNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiProductNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiProductNameListQueryKey(options)
});

export const getApiThemeListQueryKey = (options: Options<GetApiThemeListData>) => createQueryKey('getApiThemeList', options);

/**
 * API 패키지 상품 목록 조회
 */
export const getApiThemeListOptions = (options: Options<GetApiThemeListData>) => queryOptions<GetApiThemeListResponse, GetApiThemeListError, GetApiThemeListResponse, ReturnType<typeof getApiThemeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiThemeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeListQueryKey(options)
});

export const getApiThemeListInfiniteQueryKey = (options: Options<GetApiThemeListData>): QueryKey<Options<GetApiThemeListData>> => createQueryKey('getApiThemeList', options, true);

/**
 * API 패키지 상품 목록 조회
 */
export const getApiThemeListInfiniteOptions = (options: Options<GetApiThemeListData>) => {
    const opts = infiniteQueryOptions<GetApiThemeListResponse, GetApiThemeListError, InfiniteData<GetApiThemeListResponse>, QueryKey<Options<GetApiThemeListData>>, number | Pick<QueryKey<Options<GetApiThemeListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiThemeListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiThemeList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiThemeListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiThemeKeywordNameListQueryKey = (options: Options<GetApiThemeKeywordNameListData>) => createQueryKey('getApiThemeKeywordNameList', options);

/**
 * API 패키지명 검색
 */
export const getApiThemeKeywordNameListOptions = (options: Options<GetApiThemeKeywordNameListData>) => queryOptions<GetApiThemeKeywordNameListResponse, GetApiThemeKeywordNameListError, GetApiThemeKeywordNameListResponse, ReturnType<typeof getApiThemeKeywordNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiThemeKeywordNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeKeywordNameListQueryKey(options)
});

export const getApiThemeKeywordNameListInfiniteQueryKey = (options: Options<GetApiThemeKeywordNameListData>): QueryKey<Options<GetApiThemeKeywordNameListData>> => createQueryKey('getApiThemeKeywordNameList', options, true);

/**
 * API 패키지명 검색
 */
export const getApiThemeKeywordNameListInfiniteOptions = (options: Options<GetApiThemeKeywordNameListData>) => {
    const opts = infiniteQueryOptions<GetApiThemeKeywordNameListResponse, GetApiThemeKeywordNameListError, InfiniteData<GetApiThemeKeywordNameListResponse>, QueryKey<Options<GetApiThemeKeywordNameListData>>, number | Pick<QueryKey<Options<GetApiThemeKeywordNameListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiThemeKeywordNameListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiThemeKeywordNameList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiThemeKeywordNameListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiThemeNameListQueryKey = (options: Options<GetApiThemeNameListData>) => createQueryKey('getApiThemeNameList', options);

/**
 * API 패키지명 검색
 */
export const getApiThemeNameListOptions = (options: Options<GetApiThemeNameListData>) => queryOptions<GetApiThemeNameListResponse, GetApiThemeNameListError, GetApiThemeNameListResponse, ReturnType<typeof getApiThemeNameListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiThemeNameList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeNameListQueryKey(options)
});

export const getApiThemeNameListInfiniteQueryKey = (options: Options<GetApiThemeNameListData>): QueryKey<Options<GetApiThemeNameListData>> => createQueryKey('getApiThemeNameList', options, true);

/**
 * API 패키지명 검색
 */
export const getApiThemeNameListInfiniteOptions = (options: Options<GetApiThemeNameListData>) => {
    const opts = infiniteQueryOptions<GetApiThemeNameListResponse, GetApiThemeNameListError, InfiniteData<GetApiThemeNameListResponse>, QueryKey<Options<GetApiThemeNameListData>>, number | Pick<QueryKey<Options<GetApiThemeNameListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetApiThemeNameListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getApiThemeNameList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getApiThemeNameListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getApiThemeQueryKey = (options: Options<GetApiThemeData>) => createQueryKey('getApiTheme', options);

/**
 * API 패키지 상품 조회
 */
export const getApiThemeOptions = (options: Options<GetApiThemeData>) => queryOptions<GetApiThemeResponse, GetApiThemeError, GetApiThemeResponse, ReturnType<typeof getApiThemeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiTheme({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiThemeQueryKey(options)
});

export const findBenefitLotteryPoolQueryKey = (options?: Options<FindBenefitLotteryPoolData>) => createQueryKey('findBenefitLotteryPool', options);

/**
 * 로또 적립금 풀 상태 조회
 *
 * 현재 적립 금액(버림 정수), 목표 금액, 상태(ACCUMULATING/FEVER), 피버 여부, 회차를 반환합니다. 인증 불요.
 */
export const findBenefitLotteryPoolOptions = (options?: Options<FindBenefitLotteryPoolData>) => queryOptions<FindBenefitLotteryPoolResponse, FindBenefitLotteryPoolError, FindBenefitLotteryPoolResponse, ReturnType<typeof findBenefitLotteryPoolQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findBenefitLotteryPool({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findBenefitLotteryPoolQueryKey(options)
});

export const findBenefitMenuListQueryKey = (options?: Options<FindBenefitMenuListData>) => createQueryKey('findBenefitMenuList', options);

/**
 * 혜택 메뉴 목록 조회
 *
 * 전시중 혜택 메뉴를 최상위→하위 2단 계층으로 조회합니다. 전시중 하위가 없는 최상위는 제외됩니다.
 */
export const findBenefitMenuListOptions = (options?: Options<FindBenefitMenuListData>) => queryOptions<FindBenefitMenuListResponse, FindBenefitMenuListError, FindBenefitMenuListResponse, ReturnType<typeof findBenefitMenuListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findBenefitMenuList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findBenefitMenuListQueryKey(options)
});

export const findBestContentsTagListQueryKey = (options?: Options<FindBestContentsTagListData>) => createQueryKey('findBestContentsTagList', options);

/**
 * 아티클 태그 목록 조회
 *
 * 아티클 태그 목록 조회 (전시/미삭제, 정렬 순서)
 */
export const findBestContentsTagListOptions = (options?: Options<FindBestContentsTagListData>) => queryOptions<FindBestContentsTagListResponse, FindBestContentsTagListError, FindBestContentsTagListResponse, ReturnType<typeof findBestContentsTagListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findBestContentsTagList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findBestContentsTagListQueryKey(options)
});

/**
 * 블록리스트 초기화
 *
 * 블록리스트 추가된 경우 초기화 합니다
 */
export const commonCodeInit1Mutation = (options?: Partial<Options<CommonCodeInit1Data>>): UseMutationOptions<CommonCodeInit1Response, CommonCodeInit1Error, Options<CommonCodeInit1Data>> => {
    const mutationOptions: UseMutationOptions<CommonCodeInit1Response, CommonCodeInit1Error, Options<CommonCodeInit1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commonCodeInit1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCommunityWelloNewsListQueryKey = (options: Options<GetCommunityWelloNewsListData>) => createQueryKey('getCommunityWelloNewsList', options);

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsListOptions = (options: Options<GetCommunityWelloNewsListData>) => queryOptions<GetCommunityWelloNewsListResponse, GetCommunityWelloNewsListError, GetCommunityWelloNewsListResponse, ReturnType<typeof getCommunityWelloNewsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCommunityWelloNewsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunityWelloNewsListQueryKey(options)
});

export const getCommunityWelloNewsListInfiniteQueryKey = (options: Options<GetCommunityWelloNewsListData>): QueryKey<Options<GetCommunityWelloNewsListData>> => createQueryKey('getCommunityWelloNewsList', options, true);

/**
 * 커뮤니티 - 웰로 소식 목록 조회
 */
export const getCommunityWelloNewsListInfiniteOptions = (options: Options<GetCommunityWelloNewsListData>) => {
    const opts = infiniteQueryOptions<GetCommunityWelloNewsListResponse, GetCommunityWelloNewsListError, InfiniteData<GetCommunityWelloNewsListResponse>, QueryKey<Options<GetCommunityWelloNewsListData>>, number | Pick<QueryKey<Options<GetCommunityWelloNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetCommunityWelloNewsListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getCommunityWelloNewsList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCommunityWelloNewsListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const feedbackCommunityWelloNewsQueryKey = (options: Options<FeedbackCommunityWelloNewsData>) => createQueryKey('feedbackCommunityWelloNews', options);

/**
 * 커뮤니티 - 웰로 뉴스 피드백 (조회수, 좋아요 수, 댓글 수, 좋아요 확인 보정)
 */
export const feedbackCommunityWelloNewsOptions = (options: Options<FeedbackCommunityWelloNewsData>) => queryOptions<FeedbackCommunityWelloNewsResponse, FeedbackCommunityWelloNewsError, FeedbackCommunityWelloNewsResponse, ReturnType<typeof feedbackCommunityWelloNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await feedbackCommunityWelloNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: feedbackCommunityWelloNewsQueryKey(options)
});

export const getCommunityWelloNewsQueryKey = (options: Options<GetCommunityWelloNewsData>) => createQueryKey('getCommunityWelloNews', options);

/**
 * 커뮤니티 - 웰로 소식 상세
 */
export const getCommunityWelloNewsOptions = (options: Options<GetCommunityWelloNewsData>) => queryOptions<GetCommunityWelloNewsResponse, GetCommunityWelloNewsError, GetCommunityWelloNewsResponse, ReturnType<typeof getCommunityWelloNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCommunityWelloNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCommunityWelloNewsQueryKey(options)
});

export const bestContentsFeedbackQueryKey = (options: Options<BestContentsFeedbackData>) => createQueryKey('bestContentsFeedback', options);

/**
 * 정책 소식 내 고객정보 조회
 */
export const bestContentsFeedbackOptions = (options: Options<BestContentsFeedbackData>) => queryOptions<BestContentsFeedbackResponse, BestContentsFeedbackError, BestContentsFeedbackResponse, ReturnType<typeof bestContentsFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await bestContentsFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: bestContentsFeedbackQueryKey(options)
});

export const getBestContentsQueryKey = (options: Options<GetBestContentsData>) => createQueryKey('getBestContents', options);

/**
 * 정책 소식 상세 조회
 */
export const getBestContentsOptions = (options: Options<GetBestContentsData>) => queryOptions<GetBestContentsResponse, GetBestContentsError, GetBestContentsResponse, ReturnType<typeof getBestContentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBestContents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBestContentsQueryKey(options)
});

export const getControlManagementsQueryKey = (options?: Options<GetControlManagementsData>) => createQueryKey('getControlManagements', options);

/**
 * 현재 제어관리 조회
 */
export const getControlManagementsOptions = (options?: Options<GetControlManagementsData>) => queryOptions<GetControlManagementsResponse, GetControlManagementsError, GetControlManagementsResponse, ReturnType<typeof getControlManagementsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getControlManagements({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getControlManagementsQueryKey(options)
});

export const faqListQueryKey = (options?: Options<FaqListData>) => createQueryKey('faqList', options);

/**
 * FAQ 목록 조회
 *
 * FAQ 목록을 조회합니다
 */
export const faqListOptions = (options?: Options<FaqListData>) => queryOptions<FaqListResponse, FaqListError, FaqListResponse, ReturnType<typeof faqListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await faqList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: faqListQueryKey(options)
});

export const noticeList1QueryKey = (options?: Options<NoticeList1Data>) => createQueryKey('noticeList1', options);

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const noticeList1Options = (options?: Options<NoticeList1Data>) => queryOptions<NoticeList1Response, NoticeList1Error, NoticeList1Response, ReturnType<typeof noticeList1QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await noticeList1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: noticeList1QueryKey(options)
});

export const noticeQueryKey = (options: Options<NoticeData>) => createQueryKey('notice', options);

/**
 * 공지사항 조회
 *
 * 공지사항을 조회합니다
 */
export const noticeOptions = (options: Options<NoticeData>) => queryOptions<NoticeResponse, NoticeError, NoticeResponse, ReturnType<typeof noticeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await notice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: noticeQueryKey(options)
});

export const getEmergencyRoomListQueryKey = (options: Options<GetEmergencyRoomListData>) => createQueryKey('getEmergencyRoomList', options);

/**
 * 응급실 목록 조회
 */
export const getEmergencyRoomListOptions = (options: Options<GetEmergencyRoomListData>) => queryOptions<GetEmergencyRoomListResponse, GetEmergencyRoomListError, GetEmergencyRoomListResponse, ReturnType<typeof getEmergencyRoomListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomListQueryKey(options)
});

export const getEmergencyRoomListInfiniteQueryKey = (options: Options<GetEmergencyRoomListData>): QueryKey<Options<GetEmergencyRoomListData>> => createQueryKey('getEmergencyRoomList', options, true);

/**
 * 응급실 목록 조회
 */
export const getEmergencyRoomListInfiniteOptions = (options: Options<GetEmergencyRoomListData>) => {
    const opts = infiniteQueryOptions<GetEmergencyRoomListResponse, GetEmergencyRoomListError, InfiniteData<GetEmergencyRoomListResponse>, QueryKey<Options<GetEmergencyRoomListData>>, number | Pick<QueryKey<Options<GetEmergencyRoomListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEmergencyRoomListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getEmergencyRoomList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEmergencyRoomListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getEmergencyRoomCodeListQueryKey = (options?: Options<GetEmergencyRoomCodeListData>) => createQueryKey('getEmergencyRoomCodeList', options);

/**
 * 응급실 관련 코드 목록 조회
 */
export const getEmergencyRoomCodeListOptions = (options?: Options<GetEmergencyRoomCodeListData>) => queryOptions<GetEmergencyRoomCodeListResponse, GetEmergencyRoomCodeListError, GetEmergencyRoomCodeListResponse, ReturnType<typeof getEmergencyRoomCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomCodeListQueryKey(options)
});

export const getEmergencyRoomListCountQueryKey = (options: Options<GetEmergencyRoomListCountData>) => createQueryKey('getEmergencyRoomListCount', options);

/**
 * 응급실 목록 전체 개수 조회
 */
export const getEmergencyRoomListCountOptions = (options: Options<GetEmergencyRoomListCountData>) => queryOptions<GetEmergencyRoomListCountResponse, GetEmergencyRoomListCountError, GetEmergencyRoomListCountResponse, ReturnType<typeof getEmergencyRoomListCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomListCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomListCountQueryKey(options)
});

export const getEmergencyRoomListCountInfiniteQueryKey = (options: Options<GetEmergencyRoomListCountData>): QueryKey<Options<GetEmergencyRoomListCountData>> => createQueryKey('getEmergencyRoomListCount', options, true);

/**
 * 응급실 목록 전체 개수 조회
 */
export const getEmergencyRoomListCountInfiniteOptions = (options: Options<GetEmergencyRoomListCountData>) => {
    const opts = infiniteQueryOptions<GetEmergencyRoomListCountResponse, GetEmergencyRoomListCountError, InfiniteData<GetEmergencyRoomListCountResponse>, QueryKey<Options<GetEmergencyRoomListCountData>>, number | Pick<QueryKey<Options<GetEmergencyRoomListCountData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetEmergencyRoomListCountData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getEmergencyRoomListCount({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getEmergencyRoomListCountInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getEmergencyRoomRegionListQueryKey = (options: Options<GetEmergencyRoomRegionListData>) => createQueryKey('getEmergencyRoomRegionList', options);

/**
 * 응급실 지역별 갯수 조회
 */
export const getEmergencyRoomRegionListOptions = (options: Options<GetEmergencyRoomRegionListData>) => queryOptions<GetEmergencyRoomRegionListResponse, GetEmergencyRoomRegionListError, GetEmergencyRoomRegionListResponse, ReturnType<typeof getEmergencyRoomRegionListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomRegionList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomRegionListQueryKey(options)
});

export const getEmergencyRoomQueryKey = (options: Options<GetEmergencyRoomData>) => createQueryKey('getEmergencyRoom', options);

/**
 * 응급실 상세 조회
 */
export const getEmergencyRoomOptions = (options: Options<GetEmergencyRoomData>) => queryOptions<GetEmergencyRoomResponse, GetEmergencyRoomError, GetEmergencyRoomResponse, ReturnType<typeof getEmergencyRoomQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoom({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomQueryKey(options)
});

export const getEmergencyRoomLiveQueryKey = (options: Options<GetEmergencyRoomLiveData>) => createQueryKey('getEmergencyRoomLive', options);

/**
 * 응급실 실시간 데이터 조회
 */
export const getEmergencyRoomLiveOptions = (options: Options<GetEmergencyRoomLiveData>) => queryOptions<GetEmergencyRoomLiveResponse, GetEmergencyRoomLiveError, GetEmergencyRoomLiveResponse, ReturnType<typeof getEmergencyRoomLiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmergencyRoomLive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmergencyRoomLiveQueryKey(options)
});

/**
 * 애디슨 오퍼월 리워드 콜백
 *
 * Adison 서버가 리워드 지급 시 호출하는 콜백 API. 헤더 X-Hmac-Datetime/X-Hmac-Signature 로 HMAC-SHA256 검증. 요청 바디(JSON): click_key, uid, advertising_id, platform, campaign_id, ad_name, reward, reward_type. 응답은 벤더 raw {"code":200,...}, 실패 시 HTTP 400.
 */
export const callback1Mutation = (options?: Partial<Options<Callback1Data>>): UseMutationOptions<Callback1Response, Callback1Error, Options<Callback1Data>> => {
    const mutationOptions: UseMutationOptions<Callback1Response, Callback1Error, Options<Callback1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await callback1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const androidCallbackQueryKey = (options?: Options<AndroidCallbackData>) => createQueryKey('androidCallback', options);

/**
 * 애드팝콘 오퍼월 Android 리워드 콜백
 *
 * IGAWorks에서 Android 리워드 지급 시 호출되는 콜백 API
 */
export const androidCallbackOptions = (options?: Options<AndroidCallbackData>) => queryOptions<AndroidCallbackResponse, AndroidCallbackError, AndroidCallbackResponse, ReturnType<typeof androidCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await androidCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: androidCallbackQueryKey(options)
});

export const iosCallbackQueryKey = (options?: Options<IosCallbackData>) => createQueryKey('iosCallback', options);

/**
 * 애드팝콘 오퍼월 iOS 리워드 콜백
 *
 * IGAWorks에서 iOS 리워드 지급 시 호출되는 콜백 API
 */
export const iosCallbackOptions = (options?: Options<IosCallbackData>) => queryOptions<IosCallbackResponse, IosCallbackError, IosCallbackResponse, ReturnType<typeof iosCallbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await iosCallback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: iosCallbackQueryKey(options)
});

/**
 * 채무자신고 앱푸시 발송 요청(외부)
 *
 * 채무자신고 앱푸시 발송 요청 (외부)
 */
export const sendAppPushMutation = (options?: Partial<Options<SendAppPushData>>): UseMutationOptions<SendAppPushResponse, SendAppPushError, Options<SendAppPushData>> => {
    const mutationOptions: UseMutationOptions<SendAppPushResponse, SendAppPushError, Options<SendAppPushData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendAppPush({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * NICE Pay 웹훅 수신
 *
 * NICE Pay 웹훅을 처리합니다.
 */
export const handleNicePayWebhookMutation = (options?: Partial<Options<HandleNicePayWebhookData>>): UseMutationOptions<HandleNicePayWebhookResponse, HandleNicePayWebhookError, Options<HandleNicePayWebhookData>> => {
    const mutationOptions: UseMutationOptions<HandleNicePayWebhookResponse, HandleNicePayWebhookError, Options<HandleNicePayWebhookData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleNicePayWebhook({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 핀크럭스 오퍼월 리워드 콜백
 *
 * 핀크럭스 서버에서 적립금 지급 시 호출되는 콜백 API. 응답은 벤더 규격 raw JSON {"code":"00"}.
 */
export const callbackMutation = (options?: Partial<Options<CallbackData>>): UseMutationOptions<CallbackResponse, CallbackError, Options<CallbackData>> => {
    const mutationOptions: UseMutationOptions<CallbackResponse, CallbackError, Options<CallbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await callback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 피드 목록 조회
 *
 * 여러 소스의 컨텐츠를 발행일 최신순으로 정렬하여 페이징 조회합니다. (맞춤정책·기부·고향상품·테마는 목록 마지막에 배치)
 */
export const findFeedsMutation = (options?: Partial<Options<FindFeedsData>>): UseMutationOptions<FindFeedsResponse, FindFeedsError, Options<FindFeedsData>> => {
    const mutationOptions: UseMutationOptions<FindFeedsResponse, FindFeedsError, Options<FindFeedsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await findFeeds({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHomeDonationEventQueryKey = (options?: Options<GetHomeDonationEventData>) => createQueryKey('getHomeDonationEvent', options);

/**
 * 이벤트 목록 조회
 */
export const getHomeDonationEventOptions = (options?: Options<GetHomeDonationEventData>) => queryOptions<GetHomeDonationEventResponse, GetHomeDonationEventError, GetHomeDonationEventResponse, ReturnType<typeof getHomeDonationEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeDonationEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeDonationEventQueryKey(options)
});

export const getTopInviterListInAugustQueryKey = (options?: Options<GetTopInviterListInAugustData>) => createQueryKey('getTopInviterListInAugust', options);

/**
 * 초대 TOP 목록 조회(8월)
 */
export const getTopInviterListInAugustOptions = (options?: Options<GetTopInviterListInAugustData>) => queryOptions<GetTopInviterListInAugustResponse, GetTopInviterListInAugustError, GetTopInviterListInAugustResponse, ReturnType<typeof getTopInviterListInAugustQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTopInviterListInAugust({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTopInviterListInAugustQueryKey(options)
});

export const getRecentOpenedGiftBoxListQueryKey = (options?: Options<GetRecentOpenedGiftBoxListData>) => createQueryKey('getRecentOpenedGiftBoxList', options);

/**
 * 최근 선물상자 오픈 목록 조회
 */
export const getRecentOpenedGiftBoxListOptions = (options?: Options<GetRecentOpenedGiftBoxListData>) => queryOptions<GetRecentOpenedGiftBoxListResponse, GetRecentOpenedGiftBoxListError, GetRecentOpenedGiftBoxListResponse, ReturnType<typeof getRecentOpenedGiftBoxListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentOpenedGiftBoxList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentOpenedGiftBoxListQueryKey(options)
});

export const getTopDonationEventHistoryListQueryKey = (options: Options<GetTopDonationEventHistoryListData>) => createQueryKey('getTopDonationEventHistoryList', options);

/**
 * 친구 기부 TOP 목록
 */
export const getTopDonationEventHistoryListOptions = (options: Options<GetTopDonationEventHistoryListData>) => queryOptions<GetTopDonationEventHistoryListResponse, GetTopDonationEventHistoryListError, GetTopDonationEventHistoryListResponse, ReturnType<typeof getTopDonationEventHistoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTopDonationEventHistoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTopDonationEventHistoryListQueryKey(options)
});

export const getMemberNameByInviteCodeQueryKey = (options: Options<GetMemberNameByInviteCodeData>) => createQueryKey('getMemberNameByInviteCode', options);

/**
 * 초대코드로 회원 이름 조회
 */
export const getMemberNameByInviteCodeOptions = (options: Options<GetMemberNameByInviteCodeData>) => queryOptions<GetMemberNameByInviteCodeResponse, GetMemberNameByInviteCodeError, GetMemberNameByInviteCodeResponse, ReturnType<typeof getMemberNameByInviteCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMemberNameByInviteCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMemberNameByInviteCodeQueryKey(options)
});

export const getRecentEventHistoryListQueryKey = (options: Options<GetRecentEventHistoryListData>) => createQueryKey('getRecentEventHistoryList', options);

/**
 * 최근 포인트 지급 목록
 */
export const getRecentEventHistoryListOptions = (options: Options<GetRecentEventHistoryListData>) => queryOptions<GetRecentEventHistoryListResponse, GetRecentEventHistoryListError, GetRecentEventHistoryListResponse, ReturnType<typeof getRecentEventHistoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentEventHistoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentEventHistoryListQueryKey(options)
});

export const getRecentEventHistoryListInSeptemberQueryKey = (options: Options<GetRecentEventHistoryListInSeptemberData>) => createQueryKey('getRecentEventHistoryListInSeptember', options);

/**
 * 최근 포인트 지급 목록 (9월)
 */
export const getRecentEventHistoryListInSeptemberOptions = (options: Options<GetRecentEventHistoryListInSeptemberData>) => queryOptions<GetRecentEventHistoryListInSeptemberResponse, GetRecentEventHistoryListInSeptemberError, GetRecentEventHistoryListInSeptemberResponse, ReturnType<typeof getRecentEventHistoryListInSeptemberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentEventHistoryListInSeptember({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentEventHistoryListInSeptemberQueryKey(options)
});

export const isEventInProgressQueryKey = (options: Options<IsEventInProgressData>) => createQueryKey('isEventInProgress', options);

/**
 * 이벤트 진행 여부
 */
export const isEventInProgressOptions = (options: Options<IsEventInProgressData>) => queryOptions<IsEventInProgressResponse, IsEventInProgressError, IsEventInProgressResponse, ReturnType<typeof isEventInProgressQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await isEventInProgress({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: isEventInProgressQueryKey(options)
});

export const calculateDonationQueryKey = (options: Options<CalculateDonationData>) => createQueryKey('calculateDonation', options);

/**
 * 기부금 계산
 */
export const calculateDonationOptions = (options: Options<CalculateDonationData>) => queryOptions<CalculateDonationResponse, CalculateDonationError, CalculateDonationResponse, ReturnType<typeof calculateDonationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await calculateDonation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: calculateDonationQueryKey(options)
});

export const getHomeDonationHistoryByDonationBusinessListQueryKey = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>) => createQueryKey('getHomeDonationHistoryByDonationBusinessList', options);

/**
 * 지정사업 기부내역 조회
 */
export const getHomeDonationHistoryByDonationBusinessListOptions = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>) => queryOptions<GetHomeDonationHistoryByDonationBusinessListResponse, GetHomeDonationHistoryByDonationBusinessListError, GetHomeDonationHistoryByDonationBusinessListResponse, ReturnType<typeof getHomeDonationHistoryByDonationBusinessListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeDonationHistoryByDonationBusinessList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeDonationHistoryByDonationBusinessListQueryKey(options)
});

export const getHomeDonationHistoryByDonationBusinessListInfiniteQueryKey = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>): QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>> => createQueryKey('getHomeDonationHistoryByDonationBusinessList', options, true);

/**
 * 지정사업 기부내역 조회
 */
export const getHomeDonationHistoryByDonationBusinessListInfiniteOptions = (options: Options<GetHomeDonationHistoryByDonationBusinessListData>) => {
    const opts = infiniteQueryOptions<GetHomeDonationHistoryByDonationBusinessListResponse, GetHomeDonationHistoryByDonationBusinessListError, InfiniteData<GetHomeDonationHistoryByDonationBusinessListResponse>, QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>>, number | Pick<QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeDonationHistoryByDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeDonationHistoryByDonationBusinessList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeDonationHistoryByDonationBusinessListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeDonationStatisticsListQueryKey = (options?: Options<GetHomeDonationStatisticsListData>) => createQueryKey('getHomeDonationStatisticsList', options);

/**
 * 지자체별 통계(기부자 수, 기부금액)
 */
export const getHomeDonationStatisticsListOptions = (options?: Options<GetHomeDonationStatisticsListData>) => queryOptions<GetHomeDonationStatisticsListResponse, GetHomeDonationStatisticsListError, GetHomeDonationStatisticsListResponse, ReturnType<typeof getHomeDonationStatisticsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeDonationStatisticsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeDonationStatisticsListQueryKey(options)
});

export const getHomeInquiryListQueryKey = (options: Options<GetHomeInquiryListData>) => createQueryKey('getHomeInquiryList', options);

/**
 * 1:1 문의 목록 조회
 */
export const getHomeInquiryListOptions = (options: Options<GetHomeInquiryListData>) => queryOptions<GetHomeInquiryListResponse, GetHomeInquiryListError, GetHomeInquiryListResponse, ReturnType<typeof getHomeInquiryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInquiryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInquiryListQueryKey(options)
});

export const getHomeInquiryListInfiniteQueryKey = (options: Options<GetHomeInquiryListData>): QueryKey<Options<GetHomeInquiryListData>> => createQueryKey('getHomeInquiryList', options, true);

/**
 * 1:1 문의 목록 조회
 */
export const getHomeInquiryListInfiniteOptions = (options: Options<GetHomeInquiryListData>) => {
    const opts = infiniteQueryOptions<GetHomeInquiryListResponse, GetHomeInquiryListError, InfiniteData<GetHomeInquiryListResponse>, QueryKey<Options<GetHomeInquiryListData>>, number | Pick<QueryKey<Options<GetHomeInquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeInquiryListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeInquiryList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeInquiryListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeInquiryQueryKey = (options: Options<GetHomeInquiryData>) => createQueryKey('getHomeInquiry', options);

/**
 * 1:1 문의 상세 조회
 */
export const getHomeInquiryOptions = (options: Options<GetHomeInquiryData>) => queryOptions<GetHomeInquiryResponse, GetHomeInquiryError, GetHomeInquiryResponse, ReturnType<typeof getHomeInquiryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInquiry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInquiryQueryKey(options)
});

export const findChildHomeLoveGovCodeListQueryKey = (options?: Options<FindChildHomeLoveGovCodeListData>) => createQueryKey('findChildHomeLoveGovCodeList', options);

/**
 * 시군구 지자체 코드 목록 조회
 *
 * 지정한 광역시도 하위에서 전시 가능한 지자체를 보유한 시군구를 전체 지역명 가나다순으로 반환한다. 광역시도 아이디를 주지 않으면 시군구 전체를 반환한다(1depth 제외, 전시 가능 조건은 동일). 전시 가능 기준은 운영 중 · 전시 특산품 보유 · 전시 · 승인 답례품 1건 이상이다. 존재하지 않는 아이디나 광역시도가 아닌 아이디를 받으면 빈 목록을 반환한다.
 */
export const findChildHomeLoveGovCodeListOptions = (options?: Options<FindChildHomeLoveGovCodeListData>) => queryOptions<FindChildHomeLoveGovCodeListResponse, FindChildHomeLoveGovCodeListError, FindChildHomeLoveGovCodeListResponse, ReturnType<typeof findChildHomeLoveGovCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findChildHomeLoveGovCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findChildHomeLoveGovCodeListQueryKey(options)
});

export const findParentHomeLoveGovCodeListQueryKey = (options?: Options<FindParentHomeLoveGovCodeListData>) => createQueryKey('findParentHomeLoveGovCodeList', options);

/**
 * 광역시도 지자체 코드 목록 조회
 *
 * 하위 시군구에 전시 가능한 지자체를 보유한 광역시도를 지역명 가나다순으로 반환한다. 전시 가능 기준은 운영 중 · 전시 특산품 보유 · 전시 · 승인 답례품 1건 이상이다.
 */
export const findParentHomeLoveGovCodeListOptions = (options?: Options<FindParentHomeLoveGovCodeListData>) => queryOptions<FindParentHomeLoveGovCodeListResponse, FindParentHomeLoveGovCodeListError, FindParentHomeLoveGovCodeListResponse, ReturnType<typeof findParentHomeLoveGovCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findParentHomeLoveGovCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findParentHomeLoveGovCodeListQueryKey(options)
});

/**
 * 고향사랑 컨텐츠 조회수 증가
 */
export const viewHomeGiftProductMutation = (options?: Partial<Options<ViewHomeGiftProductData>>): UseMutationOptions<ViewHomeGiftProductResponse, ViewHomeGiftProductError, Options<ViewHomeGiftProductData>> => {
    const mutationOptions: UseMutationOptions<ViewHomeGiftProductResponse, ViewHomeGiftProductError, Options<ViewHomeGiftProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await viewHomeGiftProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const callbackCompleteQueryKey = (options?: Options<CallbackCompleteData>) => createQueryKey('callbackComplete', options);

/**
 * 기부 완료 처리
 */
export const callbackCompleteOptions = (options?: Options<CallbackCompleteData>) => queryOptions<unknown, CallbackCompleteError, unknown, ReturnType<typeof callbackCompleteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await callbackComplete({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: callbackCompleteQueryKey(options)
});

export const findGiftCategoryGroupProductListQueryKey = (options: Options<FindGiftCategoryGroupProductListData>) => createQueryKey('findGiftCategoryGroupProductList', options);

/**
 * 카테고리 그룹별 답례품 목록
 *
 * 선택한 카테고리 그룹에 묶인 2차 카테고리와 그 하위 답례품을 페이지로 반환한다. 운영 중인 지자체의 전시·승인된 답례품만 대상이며 품절 상품은 기본 제외한다(includeSoldOutYN=true 면 함께 조회하고 응답 productSaleStatus 에 SOLD_OUT 이 실린다). giftCategoryGroupType 은 필수이며 ALL 을 보내면 카테고리 조건 없이 전체를 조회한다.
 */
export const findGiftCategoryGroupProductListOptions = (options: Options<FindGiftCategoryGroupProductListData>) => queryOptions<FindGiftCategoryGroupProductListResponse, FindGiftCategoryGroupProductListError, FindGiftCategoryGroupProductListResponse, ReturnType<typeof findGiftCategoryGroupProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGiftCategoryGroupProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftCategoryGroupProductListQueryKey(options)
});

export const findGiftCategoryGroupProductListInfiniteQueryKey = (options: Options<FindGiftCategoryGroupProductListData>): QueryKey<Options<FindGiftCategoryGroupProductListData>> => createQueryKey('findGiftCategoryGroupProductList', options, true);

/**
 * 카테고리 그룹별 답례품 목록
 *
 * 선택한 카테고리 그룹에 묶인 2차 카테고리와 그 하위 답례품을 페이지로 반환한다. 운영 중인 지자체의 전시·승인된 답례품만 대상이며 품절 상품은 기본 제외한다(includeSoldOutYN=true 면 함께 조회하고 응답 productSaleStatus 에 SOLD_OUT 이 실린다). giftCategoryGroupType 은 필수이며 ALL 을 보내면 카테고리 조건 없이 전체를 조회한다.
 */
export const findGiftCategoryGroupProductListInfiniteOptions = (options: Options<FindGiftCategoryGroupProductListData>) => {
    const opts = infiniteQueryOptions<FindGiftCategoryGroupProductListResponse, FindGiftCategoryGroupProductListError, InfiniteData<FindGiftCategoryGroupProductListResponse>, QueryKey<Options<FindGiftCategoryGroupProductListData>>, number | Pick<QueryKey<Options<FindGiftCategoryGroupProductListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindGiftCategoryGroupProductListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findGiftCategoryGroupProductList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findGiftCategoryGroupProductListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findDailyPickListQueryKey = (options?: Options<FindDailyPickListData>) => createQueryKey('findDailyPickList', options);

/**
 * 지금 많이 조회하는 답례품
 *
 * 운영 중인 지자체별 정렬 1순위 답례품을 무작위 순서로 반환한다.
 */
export const findDailyPickListOptions = (options?: Options<FindDailyPickListData>) => queryOptions<FindDailyPickListResponse, FindDailyPickListError, FindDailyPickListResponse, ReturnType<typeof findDailyPickListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findDailyPickList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findDailyPickListQueryKey(options)
});

export const findFeaturedDonationBusinessListQueryKey = (options?: Options<FindFeaturedDonationBusinessListData>) => createQueryKey('findFeaturedDonationBusinessList', options);

/**
 * 주목할 만한 고향사업
 *
 * 운영 중인 지자체별 최신 전시 고향사업을 1건씩 무작위 순서로 반환한다.
 */
export const findFeaturedDonationBusinessListOptions = (options?: Options<FindFeaturedDonationBusinessListData>) => queryOptions<FindFeaturedDonationBusinessListResponse, FindFeaturedDonationBusinessListError, FindFeaturedDonationBusinessListResponse, ReturnType<typeof findFeaturedDonationBusinessListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findFeaturedDonationBusinessList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findFeaturedDonationBusinessListQueryKey(options)
});

export const findGiftCategoryGroupListQueryKey = (options?: Options<FindGiftCategoryGroupListData>) => createQueryKey('findGiftCategoryGroupList', options);

/**
 * 답례품 카테고리 그룹 목록
 *
 * 홈 화면 카테고리 탭용 그룹 목록을 반환한다. 그룹 구성은 서버에 하드코딩돼 있다. 판매 가능한 답례품(지자체 활성·전시·승인·품절 아님)이 하나도 없는 그룹은 제외하며, 「전체」는 상품 보유 여부와 무관하게 항상 첫 항목으로 포함된다. 응답 순서가 화면 노출 순서이며, groupCode 를 카테고리 그룹별 답례품 목록 조회에 그대로 넘긴다.
 */
export const findGiftCategoryGroupListOptions = (options?: Options<FindGiftCategoryGroupListData>) => queryOptions<FindGiftCategoryGroupListResponse, FindGiftCategoryGroupListError, FindGiftCategoryGroupListResponse, ReturnType<typeof findGiftCategoryGroupListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGiftCategoryGroupList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftCategoryGroupListQueryKey(options)
});

export const findHomeInstitutionSpecialtyListQueryKey = (options?: Options<FindHomeInstitutionSpecialtyListData>) => createQueryKey('findHomeInstitutionSpecialtyList', options);

/**
 * 지역별 특산품
 *
 * 운영 중인 지자체 중 전시 상태 특산품을 보유한 목록을 랜덤 순서로 반환한다.
 */
export const findHomeInstitutionSpecialtyListOptions = (options?: Options<FindHomeInstitutionSpecialtyListData>) => queryOptions<FindHomeInstitutionSpecialtyListResponse, FindHomeInstitutionSpecialtyListError, FindHomeInstitutionSpecialtyListResponse, ReturnType<typeof findHomeInstitutionSpecialtyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findHomeInstitutionSpecialtyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findHomeInstitutionSpecialtyListQueryKey(options)
});

export const findWeeklyBestPhotoReviewListQueryKey = (options?: Options<FindWeeklyBestPhotoReviewListData>) => createQueryKey('findWeeklyBestPhotoReviewList', options);

/**
 * 주간 BEST 포토리뷰
 *
 * 어드민이 홈 전시로 지정한 포토리뷰를 수정일 최신순 최대 20건 반환한다.
 */
export const findWeeklyBestPhotoReviewListOptions = (options?: Options<FindWeeklyBestPhotoReviewListData>) => queryOptions<FindWeeklyBestPhotoReviewListResponse, FindWeeklyBestPhotoReviewListError, FindWeeklyBestPhotoReviewListResponse, ReturnType<typeof findWeeklyBestPhotoReviewListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findWeeklyBestPhotoReviewList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findWeeklyBestPhotoReviewListQueryKey(options)
});

export const findPopularGiftProductListQueryKey = (options?: Options<FindPopularGiftProductListData>) => createQueryKey('findPopularGiftProductList', options);

/**
 * 지자체별 인기 답례품
 *
 * 지자체별 주문 수 1순위 답례품을 주문 많은 순으로 추린 뒤 무작위 순서로 반환한다.
 */
export const findPopularGiftProductListOptions = (options?: Options<FindPopularGiftProductListData>) => queryOptions<FindPopularGiftProductListResponse, FindPopularGiftProductListError, FindPopularGiftProductListResponse, ReturnType<typeof findPopularGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findPopularGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findPopularGiftProductListQueryKey(options)
});

export const findRecentGiftProductListQueryKey = (options?: Options<FindRecentGiftProductListData>) => createQueryKey('findRecentGiftProductList', options);

/**
 * 전국에서 실시간 주문중
 *
 * 호출 시각 기준 최근 24시간 내 주문된 답례품을 상품 단위로 최신순 최대 9건 반환한다.
 */
export const findRecentGiftProductListOptions = (options?: Options<FindRecentGiftProductListData>) => queryOptions<FindRecentGiftProductListResponse, FindRecentGiftProductListError, FindRecentGiftProductListResponse, ReturnType<typeof findRecentGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findRecentGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findRecentGiftProductListQueryKey(options)
});

export const getHomeNoticeListQueryKey = (options?: Options<GetHomeNoticeListData>) => createQueryKey('getHomeNoticeList', options);

/**
 * 목록 조회
 */
export const getHomeNoticeListOptions = (options?: Options<GetHomeNoticeListData>) => queryOptions<GetHomeNoticeListResponse, GetHomeNoticeListError, GetHomeNoticeListResponse, ReturnType<typeof getHomeNoticeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeNoticeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeNoticeListQueryKey(options)
});

export const getHomeNoticeListInfiniteQueryKey = (options?: Options<GetHomeNoticeListData>): QueryKey<Options<GetHomeNoticeListData>> => createQueryKey('getHomeNoticeList', options, true);

/**
 * 목록 조회
 */
export const getHomeNoticeListInfiniteOptions = (options?: Options<GetHomeNoticeListData>) => {
    const opts = infiniteQueryOptions<GetHomeNoticeListResponse, GetHomeNoticeListError, InfiniteData<GetHomeNoticeListResponse>, QueryKey<Options<GetHomeNoticeListData>>, number | Pick<QueryKey<Options<GetHomeNoticeListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeNoticeListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeNoticeList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeNoticeListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeNoticeQueryKey = (options: Options<GetHomeNoticeData>) => createQueryKey('getHomeNotice', options);

/**
 * 상세 조회
 */
export const getHomeNoticeOptions = (options: Options<GetHomeNoticeData>) => queryOptions<GetHomeNoticeResponse, GetHomeNoticeError, GetHomeNoticeResponse, ReturnType<typeof getHomeNoticeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeNotice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeNoticeQueryKey(options)
});

export const getHomePopupNoticeQueryKey = (options: Options<GetHomePopupNoticeData>) => createQueryKey('getHomePopupNotice', options);

export const getHomePopupNoticeOptions = (options: Options<GetHomePopupNoticeData>) => queryOptions<GetHomePopupNoticeResponse, GetHomePopupNoticeError, GetHomePopupNoticeResponse, ReturnType<typeof getHomePopupNoticeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomePopupNotice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomePopupNoticeQueryKey(options)
});

export const getAdminHomeSearchKeywordListQueryKey = (options: Options<GetAdminHomeSearchKeywordListData>) => createQueryKey('getAdminHomeSearchKeywordList', options);

/**
 * 검색 키워드 목록 조회
 */
export const getAdminHomeSearchKeywordListOptions = (options: Options<GetAdminHomeSearchKeywordListData>) => queryOptions<GetAdminHomeSearchKeywordListResponse, GetAdminHomeSearchKeywordListError, GetAdminHomeSearchKeywordListResponse, ReturnType<typeof getAdminHomeSearchKeywordListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAdminHomeSearchKeywordList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAdminHomeSearchKeywordListQueryKey(options)
});

export const getDonationBusinessListQueryKey = (options?: Options<GetDonationBusinessListData>) => createQueryKey('getDonationBusinessList', options);

/**
 * 지정 사업 목록
 */
export const getDonationBusinessListOptions = (options?: Options<GetDonationBusinessListData>) => queryOptions<GetDonationBusinessListResponse, GetDonationBusinessListError, GetDonationBusinessListResponse, ReturnType<typeof getDonationBusinessListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusinessList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessListQueryKey(options)
});

export const getDonationBusinessListInfiniteQueryKey = (options?: Options<GetDonationBusinessListData>): QueryKey<Options<GetDonationBusinessListData>> => createQueryKey('getDonationBusinessList', options, true);

/**
 * 지정 사업 목록
 */
export const getDonationBusinessListInfiniteOptions = (options?: Options<GetDonationBusinessListData>) => {
    const opts = infiniteQueryOptions<GetDonationBusinessListResponse, GetDonationBusinessListError, InfiniteData<GetDonationBusinessListResponse>, QueryKey<Options<GetDonationBusinessListData>>, number | Pick<QueryKey<Options<GetDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetDonationBusinessListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getDonationBusinessList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDonationBusinessListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getDonationBusinessCommentListQueryKey = (options: Options<GetDonationBusinessCommentListData>) => createQueryKey('getDonationBusinessCommentList', options);

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentListOptions = (options: Options<GetDonationBusinessCommentListData>) => queryOptions<GetDonationBusinessCommentListResponse, GetDonationBusinessCommentListError, GetDonationBusinessCommentListResponse, ReturnType<typeof getDonationBusinessCommentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusinessCommentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessCommentListQueryKey(options)
});

export const getDonationBusinessCommentListInfiniteQueryKey = (options: Options<GetDonationBusinessCommentListData>): QueryKey<Options<GetDonationBusinessCommentListData>> => createQueryKey('getDonationBusinessCommentList', options, true);

/**
 * 지정사업 응원하기 목록
 */
export const getDonationBusinessCommentListInfiniteOptions = (options: Options<GetDonationBusinessCommentListData>) => {
    const opts = infiniteQueryOptions<GetDonationBusinessCommentListResponse, GetDonationBusinessCommentListError, InfiniteData<GetDonationBusinessCommentListResponse>, QueryKey<Options<GetDonationBusinessCommentListData>>, number | Pick<QueryKey<Options<GetDonationBusinessCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetDonationBusinessCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getDonationBusinessCommentList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getDonationBusinessCommentListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeInstitutionDonationBusinessQueryKey = (options: Options<GetHomeInstitutionDonationBusinessData>) => createQueryKey('getHomeInstitutionDonationBusiness', options);

/**
 * 지자체 기부 가능한 지정 사업 조회
 */
export const getHomeInstitutionDonationBusinessOptions = (options: Options<GetHomeInstitutionDonationBusinessData>) => queryOptions<GetHomeInstitutionDonationBusinessResponse, GetHomeInstitutionDonationBusinessError, GetHomeInstitutionDonationBusinessResponse, ReturnType<typeof getHomeInstitutionDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionDonationBusinessQueryKey(options)
});

export const getInstitutionRelatedDonationBusinessQueryKey = (options: Options<GetInstitutionRelatedDonationBusinessData>) => createQueryKey('getInstitutionRelatedDonationBusiness', options);

/**
 * 특정 지자체 지정 사업 목록
 */
export const getInstitutionRelatedDonationBusinessOptions = (options: Options<GetInstitutionRelatedDonationBusinessData>) => queryOptions<GetInstitutionRelatedDonationBusinessResponse, GetInstitutionRelatedDonationBusinessError, GetInstitutionRelatedDonationBusinessResponse, ReturnType<typeof getInstitutionRelatedDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInstitutionRelatedDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInstitutionRelatedDonationBusinessQueryKey(options)
});

export const getDonationBusinessQueryKey = (options: Options<GetDonationBusinessData>) => createQueryKey('getDonationBusiness', options);

/**
 * 지정 사업 상세
 */
export const getDonationBusinessOptions = (options: Options<GetDonationBusinessData>) => queryOptions<GetDonationBusinessResponse, GetDonationBusinessError, GetDonationBusinessResponse, ReturnType<typeof getDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessQueryKey(options)
});

export const getDonationBusinessDetailCountQueryKey = (options: Options<GetDonationBusinessDetailCountData>) => createQueryKey('getDonationBusinessDetailCount', options);

/**
 * 지정 사업 상세 - 기부 & 응원 수 조회
 */
export const getDonationBusinessDetailCountOptions = (options: Options<GetDonationBusinessDetailCountData>) => queryOptions<GetDonationBusinessDetailCountResponse, GetDonationBusinessDetailCountError, GetDonationBusinessDetailCountResponse, ReturnType<typeof getDonationBusinessDetailCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDonationBusinessDetailCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDonationBusinessDetailCountQueryKey(options)
});

export const getRelatedDonationBusinessQueryKey = (options: Options<GetRelatedDonationBusinessData>) => createQueryKey('getRelatedDonationBusiness', options);

/**
 * 관련 지정 사업 목록
 */
export const getRelatedDonationBusinessOptions = (options: Options<GetRelatedDonationBusinessData>) => queryOptions<GetRelatedDonationBusinessResponse, GetRelatedDonationBusinessError, GetRelatedDonationBusinessResponse, ReturnType<typeof getRelatedDonationBusinessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRelatedDonationBusiness({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRelatedDonationBusinessQueryKey(options)
});

export const getEventAmountInfoQueryKey = (options?: Options<GetEventAmountInfoData>) => createQueryKey('getEventAmountInfo', options);

/**
 * 12월 혜택 금액 정보 조회
 */
export const getEventAmountInfoOptions = (options?: Options<GetEventAmountInfoData>) => queryOptions<GetEventAmountInfoResponse, GetEventAmountInfoError, GetEventAmountInfoResponse, ReturnType<typeof getEventAmountInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEventAmountInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEventAmountInfoQueryKey(options)
});

export const getDecemberEventGiftProductListQueryKey = (options?: Options<GetDecemberEventGiftProductListData>) => createQueryKey('getDecemberEventGiftProductList', options);

/**
 * 금일 Event2 답례품
 */
export const getDecemberEventGiftProductListOptions = (options?: Options<GetDecemberEventGiftProductListData>) => queryOptions<GetDecemberEventGiftProductListResponse, GetDecemberEventGiftProductListError, GetDecemberEventGiftProductListResponse, ReturnType<typeof getDecemberEventGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecemberEventGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecemberEventGiftProductListQueryKey(options)
});

export const getDecemberInstitutionEventInfoListQueryKey = (options?: Options<GetDecemberInstitutionEventInfoListData>) => createQueryKey('getDecemberInstitutionEventInfoList', options);

/**
 * 지역별 기부 이벤트 현황
 */
export const getDecemberInstitutionEventInfoListOptions = (options?: Options<GetDecemberInstitutionEventInfoListData>) => queryOptions<GetDecemberInstitutionEventInfoListResponse, GetDecemberInstitutionEventInfoListError, GetDecemberInstitutionEventInfoListResponse, ReturnType<typeof getDecemberInstitutionEventInfoListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecemberInstitutionEventInfoList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecemberInstitutionEventInfoListQueryKey(options)
});

export const getDecemberRandomTicketWinnerListQueryKey = (options?: Options<GetDecemberRandomTicketWinnerListData>) => createQueryKey('getDecemberRandomTicketWinnerList', options);

/**
 * 랜덤티켓 당첨자 (3등 이상)
 */
export const getDecemberRandomTicketWinnerListOptions = (options?: Options<GetDecemberRandomTicketWinnerListData>) => queryOptions<GetDecemberRandomTicketWinnerListResponse, GetDecemberRandomTicketWinnerListError, GetDecemberRandomTicketWinnerListResponse, ReturnType<typeof getDecemberRandomTicketWinnerListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDecemberRandomTicketWinnerList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDecemberRandomTicketWinnerListQueryKey(options)
});

export const findGiftCategoryListQueryKey = (options?: Options<FindGiftCategoryListData>) => createQueryKey('findGiftCategoryList', options);

/**
 * 답례품 카테고리 목록 조회
 *
 * 하위 카테고리를 children 으로 중첩해 반환한다. 전시·승인된 상품이 서브트리에 없는 카테고리는 레벨과 무관하게 제외한다. 리프 카테고리의 children 은 빈 배열이다.
 */
export const findGiftCategoryListOptions = (options?: Options<FindGiftCategoryListData>) => queryOptions<FindGiftCategoryListResponse, FindGiftCategoryListError, FindGiftCategoryListResponse, ReturnType<typeof findGiftCategoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGiftCategoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftCategoryListQueryKey(options)
});

export const findRootGiftCategoryListQueryKey = (options?: Options<FindRootGiftCategoryListData>) => createQueryKey('findRootGiftCategoryList', options);

/**
 * 최상위 답례품 카테고리 목록 조회
 *
 * 최상위(level 1) 카테고리만 반환하며 하위 카테고리는 포함하지 않는다. 전시·승인된 상품이 서브트리에 없는 카테고리는 제외한다.
 */
export const findRootGiftCategoryListOptions = (options?: Options<FindRootGiftCategoryListData>) => queryOptions<FindRootGiftCategoryListResponse, FindRootGiftCategoryListError, FindRootGiftCategoryListResponse, ReturnType<typeof findRootGiftCategoryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findRootGiftCategoryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findRootGiftCategoryListQueryKey(options)
});

export const findGiftProductListQueryKey = (options?: Options<FindGiftProductListData>) => createQueryKey('findGiftProductList', options);

/**
 * 답례품 목록 조회
 *
 * 운영 중인 지자체의 전시·승인된 답례품을 페이지로 반환한다. 품절 상품은 기본적으로 제외하며 includeSoldOutYN=true 면 함께 조회한다(응답 productSaleStatus 에 SOLD_OUT 이 실린다). categoryId 는 최상위 카테고리 기준이며 하위 카테고리 상품까지 함께 조회된다. searchKeyword 는 답례품명과 지자체명 3종(Long·Name·Short)을 부분 일치로 검색한다. 커스텀 정렬 대상 지자체를 institutionId 로 지정하면 giftProductSortType 을 무시하고 지자체가 어드민에서 지정한 노출 순번으로 정렬한다.
 */
export const findGiftProductListOptions = (options?: Options<FindGiftProductListData>) => queryOptions<FindGiftProductListResponse, FindGiftProductListError, FindGiftProductListResponse, ReturnType<typeof findGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftProductListQueryKey(options)
});

export const findGiftProductListInfiniteQueryKey = (options?: Options<FindGiftProductListData>): QueryKey<Options<FindGiftProductListData>> => createQueryKey('findGiftProductList', options, true);

/**
 * 답례품 목록 조회
 *
 * 운영 중인 지자체의 전시·승인된 답례품을 페이지로 반환한다. 품절 상품은 기본적으로 제외하며 includeSoldOutYN=true 면 함께 조회한다(응답 productSaleStatus 에 SOLD_OUT 이 실린다). categoryId 는 최상위 카테고리 기준이며 하위 카테고리 상품까지 함께 조회된다. searchKeyword 는 답례품명과 지자체명 3종(Long·Name·Short)을 부분 일치로 검색한다. 커스텀 정렬 대상 지자체를 institutionId 로 지정하면 giftProductSortType 을 무시하고 지자체가 어드민에서 지정한 노출 순번으로 정렬한다.
 */
export const findGiftProductListInfiniteOptions = (options?: Options<FindGiftProductListData>) => {
    const opts = infiniteQueryOptions<FindGiftProductListResponse, FindGiftProductListError, InfiniteData<FindGiftProductListResponse>, QueryKey<Options<FindGiftProductListData>>, number | Pick<QueryKey<Options<FindGiftProductListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindGiftProductListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findGiftProductList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findGiftProductListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getGiftProductSeoQueryKey = (options: Options<GetGiftProductSeoData>) => createQueryKey('getGiftProductSeo', options);

/**
 * 답례품 seo 조회
 */
export const getGiftProductSeoOptions = (options: Options<GetGiftProductSeoData>) => queryOptions<GetGiftProductSeoResponse, GetGiftProductSeoError, GetGiftProductSeoResponse, ReturnType<typeof getGiftProductSeoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftProductSeo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftProductSeoQueryKey(options)
});

export const findRecommendGiftProductQueryKey = (options?: Options<FindRecommendGiftProductData>) => createQueryKey('findRecommendGiftProduct', options);

/**
 * 추천 답례품 조회
 *
 * 판매 가능한 답례품 중 무작위 1건을 반환한다. 노출·승인·품절아님·운영 중인 지자체에 더해 재고까지 반영해 실제 구매 가능한 상품만 대상으로 한다. 대상이 없으면 응답에서 context 키가 생략된다(NON_NULL 직렬화).
 */
export const findRecommendGiftProductOptions = (options?: Options<FindRecommendGiftProductData>) => queryOptions<FindRecommendGiftProductResponse, FindRecommendGiftProductError, FindRecommendGiftProductResponse, ReturnType<typeof findRecommendGiftProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findRecommendGiftProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findRecommendGiftProductQueryKey(options)
});

export const getInstitutionGiftProductListQueryKey = (options: Options<GetInstitutionGiftProductListData>) => createQueryKey('getInstitutionGiftProductList', options);

/**
 * 특정 지자체 답례품 목록
 */
export const getInstitutionGiftProductListOptions = (options: Options<GetInstitutionGiftProductListData>) => queryOptions<GetInstitutionGiftProductListResponse, GetInstitutionGiftProductListError, GetInstitutionGiftProductListResponse, ReturnType<typeof getInstitutionGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInstitutionGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInstitutionGiftProductListQueryKey(options)
});

export const findGiftProductDetailQueryKey = (options: Options<FindGiftProductDetailData>) => createQueryKey('findGiftProductDetail', options);

/**
 * 답례품 상세 조회
 *
 * 승인·전시 여부로 걸러내지 않는다. 판매중지 상품도 조회되며 productSaleStatus 가 STOPPED 로 내려간다. 판매처 공지(noticeTitle·noticeContents)는 노출 기간 내일 때만 값이 실린다.
 */
export const findGiftProductDetailOptions = (options: Options<FindGiftProductDetailData>) => queryOptions<FindGiftProductDetailResponse, FindGiftProductDetailError, FindGiftProductDetailResponse, ReturnType<typeof findGiftProductDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGiftProductDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftProductDetailQueryKey(options)
});

export const findRelatedGiftProductListQueryKey = (options: Options<FindRelatedGiftProductListData>) => createQueryKey('findRelatedGiftProductList', options);

/**
 * 관련 답례품 목록(동일 지자체) 조회
 *
 * 같은 지자체의 다른 답례품을 지자체가 지정한 노출 순서로 반환한다. 노출 순번이 없는 답례품은 뒤로 보내고 상품 아이디 내림차순으로 2차 정렬한다. 전시·승인된 답례품 중 품절이 아닌 건만 대상이며 최대 4건을 반환한다.
 */
export const findRelatedGiftProductListOptions = (options: Options<FindRelatedGiftProductListData>) => queryOptions<FindRelatedGiftProductListResponse, FindRelatedGiftProductListError, FindRelatedGiftProductListResponse, ReturnType<typeof findRelatedGiftProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findRelatedGiftProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findRelatedGiftProductListQueryKey(options)
});

export const getGiftOrderProductReviewListQueryKey = (options?: Options<GetGiftOrderProductReviewListData>) => createQueryKey('getGiftOrderProductReviewList', options);

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewListOptions = (options?: Options<GetGiftOrderProductReviewListData>) => queryOptions<GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewListError, GetGiftOrderProductReviewListResponse, ReturnType<typeof getGiftOrderProductReviewListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftOrderProductReviewList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductReviewListQueryKey(options)
});

export const getGiftOrderProductReviewListInfiniteQueryKey = (options?: Options<GetGiftOrderProductReviewListData>): QueryKey<Options<GetGiftOrderProductReviewListData>> => createQueryKey('getGiftOrderProductReviewList', options, true);

/**
 * 리뷰 목록 조회
 */
export const getGiftOrderProductReviewListInfiniteOptions = (options?: Options<GetGiftOrderProductReviewListData>) => {
    const opts = infiniteQueryOptions<GetGiftOrderProductReviewListResponse, GetGiftOrderProductReviewListError, InfiniteData<GetGiftOrderProductReviewListResponse>, QueryKey<Options<GetGiftOrderProductReviewListData>>, number | Pick<QueryKey<Options<GetGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetGiftOrderProductReviewListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getGiftOrderProductReviewList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGiftOrderProductReviewListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getGiftOrderProductPhotoReviewListByProductQueryKey = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>) => createQueryKey('getGiftOrderProductPhotoReviewListByProduct', options);

/**
 * 후기 목록(포토리뷰) 조회
 */
export const getGiftOrderProductPhotoReviewListByProductOptions = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>) => queryOptions<GetGiftOrderProductPhotoReviewListByProductResponse, GetGiftOrderProductPhotoReviewListByProductError, GetGiftOrderProductPhotoReviewListByProductResponse, ReturnType<typeof getGiftOrderProductPhotoReviewListByProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftOrderProductPhotoReviewListByProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductPhotoReviewListByProductQueryKey(options)
});

export const getGiftOrderProductPhotoReviewListByProductInfiniteQueryKey = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>): QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>> => createQueryKey('getGiftOrderProductPhotoReviewListByProduct', options, true);

/**
 * 후기 목록(포토리뷰) 조회
 */
export const getGiftOrderProductPhotoReviewListByProductInfiniteOptions = (options?: Options<GetGiftOrderProductPhotoReviewListByProductData>) => {
    const opts = infiniteQueryOptions<GetGiftOrderProductPhotoReviewListByProductResponse, GetGiftOrderProductPhotoReviewListByProductError, InfiniteData<GetGiftOrderProductPhotoReviewListByProductResponse>, QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>>, number | Pick<QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetGiftOrderProductPhotoReviewListByProductData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getGiftOrderProductPhotoReviewListByProduct({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getGiftOrderProductPhotoReviewListByProductInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getGiftOrderProductReviewQueryKey = (options: Options<GetGiftOrderProductReviewData>) => createQueryKey('getGiftOrderProductReview', options);

/**
 * 리뷰 상세 조회
 */
export const getGiftOrderProductReviewOptions = (options: Options<GetGiftOrderProductReviewData>) => queryOptions<GetGiftOrderProductReviewResponse, GetGiftOrderProductReviewError, GetGiftOrderProductReviewResponse, ReturnType<typeof getGiftOrderProductReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftOrderProductReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftOrderProductReviewQueryKey(options)
});

export const findHomeInstitutionListQueryKey = (options?: Options<FindHomeInstitutionListData>) => createQueryKey('findHomeInstitutionList', options);

/**
 * 지자체 목록 조회
 *
 * 운영 중인 지자체 중 전시 상태 특산품과 답례품(전시·승인)을 모두 보유한 지자체를 가나다순으로 반환한다.
 */
export const findHomeInstitutionListOptions = (options?: Options<FindHomeInstitutionListData>) => queryOptions<FindHomeInstitutionListResponse, FindHomeInstitutionListError, FindHomeInstitutionListResponse, ReturnType<typeof findHomeInstitutionListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findHomeInstitutionList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findHomeInstitutionListQueryKey(options)
});

export const getHomeInstitutionContentListQueryKey = (options?: Options<GetHomeInstitutionContentListData>) => createQueryKey('getHomeInstitutionContentList', options);

/**
 * 지자체 컨텐츠 목록 조회
 */
export const getHomeInstitutionContentListOptions = (options?: Options<GetHomeInstitutionContentListData>) => queryOptions<GetHomeInstitutionContentListResponse, GetHomeInstitutionContentListError, GetHomeInstitutionContentListResponse, ReturnType<typeof getHomeInstitutionContentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionContentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionContentListQueryKey(options)
});

export const getHomeInstitutionContentListInfiniteQueryKey = (options?: Options<GetHomeInstitutionContentListData>): QueryKey<Options<GetHomeInstitutionContentListData>> => createQueryKey('getHomeInstitutionContentList', options, true);

/**
 * 지자체 컨텐츠 목록 조회
 */
export const getHomeInstitutionContentListInfiniteOptions = (options?: Options<GetHomeInstitutionContentListData>) => {
    const opts = infiniteQueryOptions<GetHomeInstitutionContentListResponse, GetHomeInstitutionContentListError, InfiniteData<GetHomeInstitutionContentListResponse>, QueryKey<Options<GetHomeInstitutionContentListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionContentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeInstitutionContentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeInstitutionContentList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeInstitutionContentListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeInstitutionContentQueryKey = (options: Options<GetHomeInstitutionContentData>) => createQueryKey('getHomeInstitutionContent', options);

/**
 * 지자체 컨텐츠 상세 조회
 */
export const getHomeInstitutionContentOptions = (options: Options<GetHomeInstitutionContentData>) => queryOptions<GetHomeInstitutionContentResponse, GetHomeInstitutionContentError, GetHomeInstitutionContentResponse, ReturnType<typeof getHomeInstitutionContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionContentQueryKey(options)
});

export const getHomeInstitutionEventListQueryKey = (options?: Options<GetHomeInstitutionEventListData>) => createQueryKey('getHomeInstitutionEventList', options);

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventListOptions = (options?: Options<GetHomeInstitutionEventListData>) => queryOptions<GetHomeInstitutionEventListResponse, GetHomeInstitutionEventListError, GetHomeInstitutionEventListResponse, ReturnType<typeof getHomeInstitutionEventListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionEventList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionEventListQueryKey(options)
});

export const getHomeInstitutionEventListInfiniteQueryKey = (options?: Options<GetHomeInstitutionEventListData>): QueryKey<Options<GetHomeInstitutionEventListData>> => createQueryKey('getHomeInstitutionEventList', options, true);

/**
 * 지자체 이벤트 목록 조회
 */
export const getHomeInstitutionEventListInfiniteOptions = (options?: Options<GetHomeInstitutionEventListData>) => {
    const opts = infiniteQueryOptions<GetHomeInstitutionEventListResponse, GetHomeInstitutionEventListError, InfiniteData<GetHomeInstitutionEventListResponse>, QueryKey<Options<GetHomeInstitutionEventListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionEventListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeInstitutionEventListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeInstitutionEventList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeInstitutionEventListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getOrderedHomeInstitutionEventListQueryKey = (options?: Options<GetOrderedHomeInstitutionEventListData>) => createQueryKey('getOrderedHomeInstitutionEventList', options);

/**
 * 지자체 이벤트 목록 조회(정렬)
 */
export const getOrderedHomeInstitutionEventListOptions = (options?: Options<GetOrderedHomeInstitutionEventListData>) => queryOptions<GetOrderedHomeInstitutionEventListResponse, GetOrderedHomeInstitutionEventListError, GetOrderedHomeInstitutionEventListResponse, ReturnType<typeof getOrderedHomeInstitutionEventListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderedHomeInstitutionEventList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderedHomeInstitutionEventListQueryKey(options)
});

export const getHomeInstitutionEventQueryKey = (options: Options<GetHomeInstitutionEventData>) => createQueryKey('getHomeInstitutionEvent', options);

/**
 * 지자체 이벤트 상세 조회
 */
export const getHomeInstitutionEventOptions = (options: Options<GetHomeInstitutionEventData>) => queryOptions<GetHomeInstitutionEventResponse, GetHomeInstitutionEventError, GetHomeInstitutionEventResponse, ReturnType<typeof getHomeInstitutionEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionEventQueryKey(options)
});

export const getHomeLoveGovCodeToIdQueryKey = (options: Options<GetHomeLoveGovCodeToIdData>) => createQueryKey('getHomeLoveGovCodeToId', options);

/**
 * 지자체 코드로 ID 조회
 */
export const getHomeLoveGovCodeToIdOptions = (options: Options<GetHomeLoveGovCodeToIdData>) => queryOptions<GetHomeLoveGovCodeToIdResponse, GetHomeLoveGovCodeToIdError, GetHomeLoveGovCodeToIdResponse, ReturnType<typeof getHomeLoveGovCodeToIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeLoveGovCodeToId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeLoveGovCodeToIdQueryKey(options)
});

export const getHomeInstitutionListForSearchFilterQueryKey = (options?: Options<GetHomeInstitutionListForSearchFilterData>) => createQueryKey('getHomeInstitutionListForSearchFilter', options);

/**
 * 지자체 목록 조회(검색필터용)
 */
export const getHomeInstitutionListForSearchFilterOptions = (options?: Options<GetHomeInstitutionListForSearchFilterData>) => queryOptions<GetHomeInstitutionListForSearchFilterResponse, GetHomeInstitutionListForSearchFilterError, GetHomeInstitutionListForSearchFilterResponse, ReturnType<typeof getHomeInstitutionListForSearchFilterQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionListForSearchFilter({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionListForSearchFilterQueryKey(options)
});

export const getHomeInstitutionPolicyListQueryKey = (options: Options<GetHomeInstitutionPolicyListData>) => createQueryKey('getHomeInstitutionPolicyList', options);

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyListOptions = (options: Options<GetHomeInstitutionPolicyListData>) => queryOptions<GetHomeInstitutionPolicyListResponse, GetHomeInstitutionPolicyListError, GetHomeInstitutionPolicyListResponse, ReturnType<typeof getHomeInstitutionPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionPolicyListQueryKey(options)
});

export const getHomeInstitutionPolicyListInfiniteQueryKey = (options: Options<GetHomeInstitutionPolicyListData>): QueryKey<Options<GetHomeInstitutionPolicyListData>> => createQueryKey('getHomeInstitutionPolicyList', options, true);

/**
 * 지자체 정책 목록 조회
 */
export const getHomeInstitutionPolicyListInfiniteOptions = (options: Options<GetHomeInstitutionPolicyListData>) => {
    const opts = infiniteQueryOptions<GetHomeInstitutionPolicyListResponse, GetHomeInstitutionPolicyListError, InfiniteData<GetHomeInstitutionPolicyListResponse>, QueryKey<Options<GetHomeInstitutionPolicyListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeInstitutionPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeInstitutionPolicyList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeInstitutionPolicyListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeInstitutionBenefitListQueryKey = (options: Options<GetHomeInstitutionBenefitListData>) => createQueryKey('getHomeInstitutionBenefitList', options);

/**
 * 위경도 기반 혜택 제공기관 검색
 */
export const getHomeInstitutionBenefitListOptions = (options: Options<GetHomeInstitutionBenefitListData>) => queryOptions<GetHomeInstitutionBenefitListResponse, GetHomeInstitutionBenefitListError, GetHomeInstitutionBenefitListResponse, ReturnType<typeof getHomeInstitutionBenefitListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitListQueryKey(options)
});

export const getHomeInstitutionBenefitListInfiniteQueryKey = (options: Options<GetHomeInstitutionBenefitListData>): QueryKey<Options<GetHomeInstitutionBenefitListData>> => createQueryKey('getHomeInstitutionBenefitList', options, true);

/**
 * 위경도 기반 혜택 제공기관 검색
 */
export const getHomeInstitutionBenefitListInfiniteOptions = (options: Options<GetHomeInstitutionBenefitListData>) => {
    const opts = infiniteQueryOptions<GetHomeInstitutionBenefitListResponse, GetHomeInstitutionBenefitListError, InfiniteData<GetHomeInstitutionBenefitListResponse>, QueryKey<Options<GetHomeInstitutionBenefitListData>>, number | Pick<QueryKey<Options<GetHomeInstitutionBenefitListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeInstitutionBenefitListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeInstitutionBenefitList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeInstitutionBenefitListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeInstitutionBenefitListAllQueryKey = (options: Options<GetHomeInstitutionBenefitListAllData>) => createQueryKey('getHomeInstitutionBenefitListAll', options);

/**
 * 위경도 기반 혜텍 제공기관 전체 검색
 *
 * @deprecated
 */
export const getHomeInstitutionBenefitListAllOptions = (options: Options<GetHomeInstitutionBenefitListAllData>) => queryOptions<GetHomeInstitutionBenefitListAllResponse, GetHomeInstitutionBenefitListAllError, GetHomeInstitutionBenefitListAllResponse, ReturnType<typeof getHomeInstitutionBenefitListAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitListAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitListAllQueryKey(options)
});

export const getHomeInstitutionBenefitListAllInfiniteQueryKey = (options: Options<GetHomeInstitutionBenefitListAllData>): QueryKey<Options<GetHomeInstitutionBenefitListAllData>> => createQueryKey('getHomeInstitutionBenefitListAll', options, true);

/**
 * 위경도 기반 혜텍 제공기관 전체 검색
 *
 * @deprecated
 */
export const getHomeInstitutionBenefitListAllInfiniteOptions = (options: Options<GetHomeInstitutionBenefitListAllData>) => {
    const opts = infiniteQueryOptions<GetHomeInstitutionBenefitListAllResponse, GetHomeInstitutionBenefitListAllError, InfiniteData<GetHomeInstitutionBenefitListAllResponse>, QueryKey<Options<GetHomeInstitutionBenefitListAllData>>, number | Pick<QueryKey<Options<GetHomeInstitutionBenefitListAllData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetHomeInstitutionBenefitListAllData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getHomeInstitutionBenefitListAll({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHomeInstitutionBenefitListAllInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getHomeInstitutionBenefitPrivateListQueryKey = (options: Options<GetHomeInstitutionBenefitPrivateListData>) => createQueryKey('getHomeInstitutionBenefitPrivateList', options);

/**
 * 위경도 기반 혜텍 제공기관 - 민영
 */
export const getHomeInstitutionBenefitPrivateListOptions = (options: Options<GetHomeInstitutionBenefitPrivateListData>) => queryOptions<GetHomeInstitutionBenefitPrivateListResponse, GetHomeInstitutionBenefitPrivateListError, GetHomeInstitutionBenefitPrivateListResponse, ReturnType<typeof getHomeInstitutionBenefitPrivateListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitPrivateList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitPrivateListQueryKey(options)
});

export const getHomeInstitutionBenefitPublicListQueryKey = (options: Options<GetHomeInstitutionBenefitPublicListData>) => createQueryKey('getHomeInstitutionBenefitPublicList', options);

/**
 * 위경도 기반 혜텍 제공기관 - 공영
 */
export const getHomeInstitutionBenefitPublicListOptions = (options: Options<GetHomeInstitutionBenefitPublicListData>) => queryOptions<GetHomeInstitutionBenefitPublicListResponse, GetHomeInstitutionBenefitPublicListError, GetHomeInstitutionBenefitPublicListResponse, ReturnType<typeof getHomeInstitutionBenefitPublicListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitPublicList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitPublicListQueryKey(options)
});

export const getHomeInstitutionBenefitRegionListQueryKey = (options: Options<GetHomeInstitutionBenefitRegionListData>) => createQueryKey('getHomeInstitutionBenefitRegionList', options);

/**
 * 위경도 기반 혜택 제공기관 지역별 갯수 검색
 */
export const getHomeInstitutionBenefitRegionListOptions = (options: Options<GetHomeInstitutionBenefitRegionListData>) => queryOptions<GetHomeInstitutionBenefitRegionListResponse, GetHomeInstitutionBenefitRegionListError, GetHomeInstitutionBenefitRegionListResponse, ReturnType<typeof getHomeInstitutionBenefitRegionListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitutionBenefitRegionList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionBenefitRegionListQueryKey(options)
});

export const getHomeInstitutionQueryKey = (options: Options<GetHomeInstitutionData>) => createQueryKey('getHomeInstitution', options);

/**
 * 지자체 정보 조회
 */
export const getHomeInstitutionOptions = (options: Options<GetHomeInstitutionData>) => queryOptions<GetHomeInstitutionResponse, GetHomeInstitutionError, GetHomeInstitutionResponse, ReturnType<typeof getHomeInstitutionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHomeInstitution({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHomeInstitutionQueryKey(options)
});

export const hometownNewsFeedbackQueryKey = (options: Options<HometownNewsFeedbackData>) => createQueryKey('hometownNewsFeedback', options);

/**
 * 비로그인 멤버 동네 소식 좋아요&스크랩 정보 조회
 */
export const hometownNewsFeedbackOptions = (options: Options<HometownNewsFeedbackData>) => queryOptions<HometownNewsFeedbackResponse, HometownNewsFeedbackError, HometownNewsFeedbackResponse, ReturnType<typeof hometownNewsFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hometownNewsFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hometownNewsFeedbackQueryKey(options)
});

export const hometownNewsQueryKey = (options: Options<HometownNewsData>) => createQueryKey('hometownNews', options);

/**
 * 동네 소식 상세
 */
export const hometownNewsOptions = (options: Options<HometownNewsData>) => queryOptions<HometownNewsResponse, HometownNewsError, HometownNewsResponse, ReturnType<typeof hometownNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await hometownNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: hometownNewsQueryKey(options)
});

export const getRelatedHometownNewsListQueryKey = (options: Options<GetRelatedHometownNewsListData>) => createQueryKey('getRelatedHometownNewsList', options);

/**
 * 관련 동네소식 목록 조회(최대 10개)
 */
export const getRelatedHometownNewsListOptions = (options: Options<GetRelatedHometownNewsListData>) => queryOptions<GetRelatedHometownNewsListResponse, GetRelatedHometownNewsListError, GetRelatedHometownNewsListResponse, ReturnType<typeof getRelatedHometownNewsListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRelatedHometownNewsList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRelatedHometownNewsListQueryKey(options)
});

export const allowsInterestPolicyListQueryKey = (options: Options<AllowsInterestPolicyListData>) => createQueryKey('allowsInterestPolicyList', options);

/**
 * 관심 분야별 정책 조회
 */
export const allowsInterestPolicyListOptions = (options: Options<AllowsInterestPolicyListData>) => queryOptions<AllowsInterestPolicyListResponse, AllowsInterestPolicyListError, AllowsInterestPolicyListResponse, ReturnType<typeof allowsInterestPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await allowsInterestPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: allowsInterestPolicyListQueryKey(options)
});

export const allowsInterestPolicyListInfiniteQueryKey = (options: Options<AllowsInterestPolicyListData>): QueryKey<Options<AllowsInterestPolicyListData>> => createQueryKey('allowsInterestPolicyList', options, true);

/**
 * 관심 분야별 정책 조회
 */
export const allowsInterestPolicyListInfiniteOptions = (options: Options<AllowsInterestPolicyListData>) => {
    const opts = infiniteQueryOptions<AllowsInterestPolicyListResponse, AllowsInterestPolicyListError, InfiniteData<AllowsInterestPolicyListResponse>, QueryKey<Options<AllowsInterestPolicyListData>>, number | Pick<QueryKey<Options<AllowsInterestPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AllowsInterestPolicyListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await allowsInterestPolicyList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: allowsInterestPolicyListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * 이벤트 참여 요청
 */
export const joinEventMutation = (options?: Partial<Options<JoinEventData>>): UseMutationOptions<JoinEventResponse, JoinEventError, Options<JoinEventData>> => {
    const mutationOptions: UseMutationOptions<JoinEventResponse, JoinEventError, Options<JoinEventData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await joinEvent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * KB PAY 회원 탈회
 */
export const resignWelloWithKbPayMutation = (options?: Partial<Options<ResignWelloWithKbPayData>>): UseMutationOptions<ResignWelloWithKbPayResponse, ResignWelloWithKbPayError, Options<ResignWelloWithKbPayData>> => {
    const mutationOptions: UseMutationOptions<ResignWelloWithKbPayResponse, ResignWelloWithKbPayError, Options<ResignWelloWithKbPayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resignWelloWithKbPay({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * KB PAY 회원 웰로 로그인
 *
 * @deprecated
 */
export const loginWelloWithKbPay1Mutation = (options?: Partial<Options<LoginWelloWithKbPay1Data>>): UseMutationOptions<LoginWelloWithKbPay1Response, LoginWelloWithKbPay1Error, Options<LoginWelloWithKbPay1Data>> => {
    const mutationOptions: UseMutationOptions<LoginWelloWithKbPay1Response, LoginWelloWithKbPay1Error, Options<LoginWelloWithKbPay1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWelloWithKbPay1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getInstitutionSpecialtyListQueryKey = (options?: Options<GetInstitutionSpecialtyListData>) => createQueryKey('getInstitutionSpecialtyList', options);

/**
 * 지역별 특산품
 */
export const getInstitutionSpecialtyListOptions = (options?: Options<GetInstitutionSpecialtyListData>) => queryOptions<GetInstitutionSpecialtyListResponse, GetInstitutionSpecialtyListError, GetInstitutionSpecialtyListResponse, ReturnType<typeof getInstitutionSpecialtyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getInstitutionSpecialtyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getInstitutionSpecialtyListQueryKey(options)
});

export const findGeneralDownloadableCouponsQueryKey = (options: Options<FindGeneralDownloadableCouponsData>) => createQueryKey('findGeneralDownloadableCoupons', options);

/**
 * 일반 다운로드 가능 쿠폰 목록 조회 (공개)
 *
 * 비인증 사용자용 상품별 일반 다운로드 가능 쿠폰 목록 조회
 */
export const findGeneralDownloadableCouponsOptions = (options: Options<FindGeneralDownloadableCouponsData>) => queryOptions<FindGeneralDownloadableCouponsResponse, FindGeneralDownloadableCouponsError, FindGeneralDownloadableCouponsResponse, ReturnType<typeof findGeneralDownloadableCouponsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGeneralDownloadableCoupons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGeneralDownloadableCouponsQueryKey(options)
});

export const getGiftReviewFeedQueryKey = (options: Options<GetGiftReviewFeedData>) => createQueryKey('getGiftReviewFeed', options);

/**
 * 기부자 만족 상품 피드 조회 (메인 화면)
 *
 * 기부자 만족 상품 피드 조회.
 *
 * <p>상품 ID로 매핑된 답례품의 기부자 만족도와 리뷰 미리보기를 반환합니다.
 * 리뷰는 최신순 N건만 반환됩니다.</p>
 */
export const getGiftReviewFeedOptions = (options: Options<GetGiftReviewFeedData>) => queryOptions<GetGiftReviewFeedResponse, GetGiftReviewFeedError, GetGiftReviewFeedResponse, ReturnType<typeof getGiftReviewFeedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGiftReviewFeed({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGiftReviewFeedQueryKey(options)
});

/**
 * NicePay 인증 결과 수신 (returnUrl)
 *
 * NicePay 인증 결과 수신 및 결제 승인 처리.
 *
 * <p>Content-Type: application/x-www-form-urlencoded
 * NicePay가 POST로 전송하는 파라미터를 @RequestParam으로 수신한다.
 * 처리 후 프론트엔드 성공/실패 페이지로 302 redirect한다.</p>
 */
export const handleAuthResultMutation = (options?: Partial<Options<HandleAuthResultData>>): UseMutationOptions<unknown, HandleAuthResultError, Options<HandleAuthResultData>> => {
    const mutationOptions: UseMutationOptions<unknown, HandleAuthResultError, Options<HandleAuthResultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleAuthResult({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProductFeedListQueryKey = (options?: Options<GetProductFeedListData>) => createQueryKey('getProductFeedList', options);

/**
 * 상품 피드 목록 조회 (메인)
 *
 * 상품 피드 목록 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/product-feeds</code></p>
 *
 * <p>판매중인 상품을 페이징하여 조회합니다.
 * 태그(프리미엄/최저가도전/무료배송), 리뷰 통계, 가격/할인 정보를 포함합니다.</p>
 */
export const getProductFeedListOptions = (options?: Options<GetProductFeedListData>) => queryOptions<GetProductFeedListResponse, GetProductFeedListError, GetProductFeedListResponse, ReturnType<typeof getProductFeedListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductFeedList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductFeedListQueryKey(options)
});

export const getProductFeedListInfiniteQueryKey = (options?: Options<GetProductFeedListData>): QueryKey<Options<GetProductFeedListData>> => createQueryKey('getProductFeedList', options, true);

/**
 * 상품 피드 목록 조회 (메인)
 *
 * 상품 피드 목록 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/product-feeds</code></p>
 *
 * <p>판매중인 상품을 페이징하여 조회합니다.
 * 태그(프리미엄/최저가도전/무료배송), 리뷰 통계, 가격/할인 정보를 포함합니다.</p>
 */
export const getProductFeedListInfiniteOptions = (options?: Options<GetProductFeedListData>) => {
    const opts = infiniteQueryOptions<GetProductFeedListResponse, GetProductFeedListError, InfiniteData<GetProductFeedListResponse>, QueryKey<Options<GetProductFeedListData>>, number | Pick<QueryKey<Options<GetProductFeedListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetProductFeedListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getProductFeedList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getProductFeedListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getProductDetailByProductNumberQueryKey = (options: Options<GetProductDetailByProductNumberData>) => createQueryKey('getProductDetailByProductNumber', options);

/**
 * 상품번호로 상품 상세 조회
 *
 * 상품번호로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>}</p>
 *
 * <p>상품번호(productNumber)는 상품 등록 시 자동 생성되는 고유 식별자이다.
 * 컨트롤러 레벨에서 정규식 패턴을 검증하여, 형식에 맞지 않는 요청은
 * DB 조회 없이 즉시 에러를 반환한다.</p>
 */
export const getProductDetailByProductNumberOptions = (options: Options<GetProductDetailByProductNumberData>) => queryOptions<GetProductDetailByProductNumberResponse, GetProductDetailByProductNumberError, GetProductDetailByProductNumberResponse, ReturnType<typeof getProductDetailByProductNumberQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductDetailByProductNumber({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductDetailByProductNumberQueryKey(options)
});

export const getProductSeoQueryKey = (options: Options<GetProductSeoData>) => createQueryKey('getProductSeo', options);

/**
 * 상품번호로 SEO 정보 조회 (비인증)
 *
 * 상품번호로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/by-product-number/{productNumber</code>/seo}</p>
 */
export const getProductSeoOptions = (options: Options<GetProductSeoData>) => queryOptions<GetProductSeoResponse, GetProductSeoError, GetProductSeoResponse, ReturnType<typeof getProductSeoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductSeo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductSeoQueryKey(options)
});

export const getProductDetailQueryKey = (options: Options<GetProductDetailData>) => createQueryKey('getProductDetail', options);

/**
 * 상품 상세 조회
 *
 * 상품 ID(UUID)로 상품 상세 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>}</p>
 *
 * <p>Spring이 <code>@PathVariable UUID</code> 타입 변환 시 UUID 형식이 아니면 자동으로 400 에러를 반환한다.</p>
 */
export const getProductDetailOptions = (options: Options<GetProductDetailData>) => queryOptions<GetProductDetailResponse, GetProductDetailError, GetProductDetailResponse, ReturnType<typeof getProductDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductDetailQueryKey(options)
});

export const findAllInquiriesQueryKey = (options: Options<FindAllInquiriesData>) => createQueryKey('findAllInquiries', options);

/**
 * 상품 문의 목록 조회
 *
 * 상품 문의 목록 조회
 */
export const findAllInquiriesOptions = (options: Options<FindAllInquiriesData>) => queryOptions<FindAllInquiriesResponse, FindAllInquiriesError, FindAllInquiriesResponse, ReturnType<typeof findAllInquiriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findAllInquiries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findAllInquiriesQueryKey(options)
});

export const findAllInquiriesInfiniteQueryKey = (options: Options<FindAllInquiriesData>): QueryKey<Options<FindAllInquiriesData>> => createQueryKey('findAllInquiries', options, true);

/**
 * 상품 문의 목록 조회
 *
 * 상품 문의 목록 조회
 */
export const findAllInquiriesInfiniteOptions = (options: Options<FindAllInquiriesData>) => {
    const opts = infiniteQueryOptions<FindAllInquiriesResponse, FindAllInquiriesError, InfiniteData<FindAllInquiriesResponse>, QueryKey<Options<FindAllInquiriesData>>, number | Pick<QueryKey<Options<FindAllInquiriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindAllInquiriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findAllInquiries({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findAllInquiriesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findInquiryQueryKey = (options: Options<FindInquiryData>) => createQueryKey('findInquiry', options);

/**
 * 상품 문의 상세 조회
 *
 * 상품 문의 상세 조회
 */
export const findInquiryOptions = (options: Options<FindInquiryData>) => queryOptions<FindInquiryResponse, FindInquiryError, FindInquiryResponse, ReturnType<typeof findInquiryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findInquiry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findInquiryQueryKey(options)
});

export const findReviewsQueryKey = (options: Options<FindReviewsData>) => createQueryKey('findReviews', options);

/**
 * 상품 리뷰 목록 조회
 *
 * 상품 ID로 상품 리뷰 목록을 조회한다.
 */
export const findReviewsOptions = (options: Options<FindReviewsData>) => queryOptions<FindReviewsResponse, FindReviewsError, FindReviewsResponse, ReturnType<typeof findReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findReviewsQueryKey(options)
});

export const findReviewsInfiniteQueryKey = (options: Options<FindReviewsData>): QueryKey<Options<FindReviewsData>> => createQueryKey('findReviews', options, true);

/**
 * 상품 리뷰 목록 조회
 *
 * 상품 ID로 상품 리뷰 목록을 조회한다.
 */
export const findReviewsInfiniteOptions = (options: Options<FindReviewsData>) => {
    const opts = infiniteQueryOptions<FindReviewsResponse, FindReviewsError, InfiniteData<FindReviewsResponse>, QueryKey<Options<FindReviewsData>>, number | Pick<QueryKey<Options<FindReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findReviews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findReviewsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findPhotoReviewsQueryKey = (options: Options<FindPhotoReviewsData>) => createQueryKey('findPhotoReviews', options);

/**
 * 상품 포토 리뷰 목록 조회
 *
 * 상품 포토 리뷰 이미지 목록 조회
 */
export const findPhotoReviewsOptions = (options: Options<FindPhotoReviewsData>) => queryOptions<FindPhotoReviewsResponse, FindPhotoReviewsError, FindPhotoReviewsResponse, ReturnType<typeof findPhotoReviewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findPhotoReviews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findPhotoReviewsQueryKey(options)
});

export const findPhotoReviewsInfiniteQueryKey = (options: Options<FindPhotoReviewsData>): QueryKey<Options<FindPhotoReviewsData>> => createQueryKey('findPhotoReviews', options, true);

/**
 * 상품 포토 리뷰 목록 조회
 *
 * 상품 포토 리뷰 이미지 목록 조회
 */
export const findPhotoReviewsInfiniteOptions = (options: Options<FindPhotoReviewsData>) => {
    const opts = infiniteQueryOptions<FindPhotoReviewsResponse, FindPhotoReviewsError, InfiniteData<FindPhotoReviewsResponse>, QueryKey<Options<FindPhotoReviewsData>>, number | Pick<QueryKey<Options<FindPhotoReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindPhotoReviewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findPhotoReviews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findPhotoReviewsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findReviewQueryKey = (options: Options<FindReviewData>) => createQueryKey('findReview', options);

/**
 * 상품 리뷰 상세 조회
 *
 * 상품 리뷰 상세를 조회한다.
 */
export const findReviewOptions = (options: Options<FindReviewData>) => queryOptions<FindReviewResponse, FindReviewError, FindReviewResponse, ReturnType<typeof findReviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findReview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findReviewQueryKey(options)
});

export const getProductSeoByProductIdQueryKey = (options: Options<GetProductSeoByProductIdData>) => createQueryKey('getProductSeoByProductId', options);

/**
 * 상품 ID로 SEO 정보 조회 (비인증)
 *
 * 상품 ID(UUID)로 SEO 정보 조회.
 *
 * <p>엔드포인트: <code>GET /wello/v2/allows/local-market/products/{productId</code>/seo}</p>
 */
export const getProductSeoByProductIdOptions = (options: Options<GetProductSeoByProductIdData>) => queryOptions<GetProductSeoByProductIdResponse, GetProductSeoByProductIdError, GetProductSeoByProductIdResponse, ReturnType<typeof getProductSeoByProductIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductSeoByProductId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductSeoByProductIdQueryKey(options)
});

export const termHistoryQueryKey = (options: Options<TermHistoryData>) => createQueryKey('termHistory', options);

/**
 * 약관 변경 이력을 조회합니다.
 *
 * 약관 변경이력 조회
 */
export const termHistoryOptions = (options: Options<TermHistoryData>) => queryOptions<TermHistoryResponse, TermHistoryError, TermHistoryResponse, ReturnType<typeof termHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await termHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termHistoryQueryKey(options)
});

export const getActiveMaintenanceListQueryKey = (options?: Options<GetActiveMaintenanceListData>) => createQueryKey('getActiveMaintenanceList', options);

/**
 * 현재 활성화된 점검 목록 조회
 *
 * 현재 활성화된 점검 목록 조회
 */
export const getActiveMaintenanceListOptions = (options?: Options<GetActiveMaintenanceListData>) => queryOptions<GetActiveMaintenanceListResponse, GetActiveMaintenanceListError, GetActiveMaintenanceListResponse, ReturnType<typeof getActiveMaintenanceListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getActiveMaintenanceList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getActiveMaintenanceListQueryKey(options)
});

export const getMaintenanceQueryKey = (options: Options<GetMaintenanceData>) => createQueryKey('getMaintenance', options);

/**
 * 특정 점검 상세 조회
 *
 * 특정 점검 상세 조회
 */
export const getMaintenanceOptions = (options: Options<GetMaintenanceData>) => queryOptions<GetMaintenanceResponse, GetMaintenanceError, GetMaintenanceResponse, ReturnType<typeof getMaintenanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMaintenance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaintenanceQueryKey(options)
});

export const getMedianIncomeListQueryKey = (options?: Options<GetMedianIncomeListData>) => createQueryKey('getMedianIncomeList', options);

/**
 * 중위소득 조회
 */
export const getMedianIncomeListOptions = (options?: Options<GetMedianIncomeListData>) => queryOptions<GetMedianIncomeListResponse, GetMedianIncomeListError, GetMedianIncomeListResponse, ReturnType<typeof getMedianIncomeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMedianIncomeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMedianIncomeListQueryKey(options)
});

/**
 * 웰로 회원 탈퇴(관리자용, 다건)
 *
 * 최대 100명까지 일괄 탈퇴 처리한다. 요청한 memberOAuthId 중 웰로 회원이 아닌 건(returnCode 30404)이나 KB 연동 회원(returnCode 30400)이 하나라도 있으면 아무것도 처리하지 않고 해당 memberOAuthId 목록을 담은 오류를 반환한다. KB 연동 회원은 외부 채널 회원 탈퇴 API 를 사용한다.
 */
export const resignMembersMutation = (options?: Partial<Options<ResignMembersData>>): UseMutationOptions<ResignMembersResponse, ResignMembersError, Options<ResignMembersData>> => {
    const mutationOptions: UseMutationOptions<ResignMembersResponse, ResignMembersError, Options<ResignMembersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resignMembers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * @deprecated
 */
export const welloBeforeLoginMutation = (options?: Partial<Options<WelloBeforeLoginData>>): UseMutationOptions<WelloBeforeLoginResponse, WelloBeforeLoginError, Options<WelloBeforeLoginData>> => {
    const mutationOptions: UseMutationOptions<WelloBeforeLoginResponse, WelloBeforeLoginError, Options<WelloBeforeLoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await welloBeforeLogin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getKbMemberLoginTypeList1QueryKey = (options: Options<GetKbMemberLoginTypeList1Data>) => createQueryKey('getKbMemberLoginTypeList1', options);

/**
 * @deprecated
 */
export const getKbMemberLoginTypeList1Options = (options: Options<GetKbMemberLoginTypeList1Data>) => queryOptions<GetKbMemberLoginTypeList1Response, GetKbMemberLoginTypeList1Error, GetKbMemberLoginTypeList1Response, ReturnType<typeof getKbMemberLoginTypeList1QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getKbMemberLoginTypeList1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKbMemberLoginTypeList1QueryKey(options)
});

/**
 * @deprecated
 */
export const loginWelloSnsMember1Mutation = (options?: Partial<Options<LoginWelloSnsMember1Data>>): UseMutationOptions<LoginWelloSnsMember1Response, LoginWelloSnsMember1Error, Options<LoginWelloSnsMember1Data>> => {
    const mutationOptions: UseMutationOptions<LoginWelloSnsMember1Response, LoginWelloSnsMember1Error, Options<LoginWelloSnsMember1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWelloSnsMember1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const snsRefreshToken1QueryKey = (options: Options<SnsRefreshToken1Data>) => createQueryKey('snsRefreshToken1', options);

/**
 * @deprecated
 */
export const snsRefreshToken1Options = (options: Options<SnsRefreshToken1Data>) => queryOptions<SnsRefreshToken1Response, SnsRefreshToken1Error, SnsRefreshToken1Response, ReturnType<typeof snsRefreshToken1QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await snsRefreshToken1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: snsRefreshToken1QueryKey(options)
});

export const noticeListQueryKey = (options?: Options<NoticeListData>) => createQueryKey('noticeList', options);

/**
 * 신규 닉네임 조회
 *
 * 신규 닉네임을 조회합니다
 */
export const noticeListOptions = (options?: Options<NoticeListData>) => queryOptions<NoticeListResponse, NoticeListError, NoticeListResponse, ReturnType<typeof noticeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await noticeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: noticeListQueryKey(options)
});

/**
 * 외부 채널 연동 회원 탈퇴(관리자용, 단건)
 *
 * KB 등 외부 채널에 연동된 회원을 탈퇴 처리한다. 웰로 쪽 탈퇴가 커밋된 뒤 외부 채널 철회 API 를 호출하므로, 성공 응답은 웰로 탈퇴 완료를 뜻하고 외부 채널 철회 결과는 포함하지 않는다. 외부 채널 연동 회원이 아니면 returnCode 30400 을 반환한다. 다건은 지원하지 않는다.
 */
export const resignExternalChannelMemberMutation = (options?: Partial<Options<ResignExternalChannelMemberData>>): UseMutationOptions<ResignExternalChannelMemberResponse, ResignExternalChannelMemberError, Options<ResignExternalChannelMemberData>> => {
    const mutationOptions: UseMutationOptions<ResignExternalChannelMemberResponse, ResignExternalChannelMemberError, Options<ResignExternalChannelMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resignExternalChannelMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const rejectMessageMutation = (options?: Partial<Options<RejectMessageData>>): UseMutationOptions<RejectMessageResponse, RejectMessageError, Options<RejectMessageData>> => {
    const mutationOptions: UseMutationOptions<RejectMessageResponse, RejectMessageError, Options<RejectMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const metaCodeAllQueryKey = (options: Options<MetaCodeAllData>) => createQueryKey('metaCodeAll', options);

/**
 * 메타코드 정보 조회
 *
 * 메타코드 및 메타코드의 하위 코드까지 조회합니다
 */
export const metaCodeAllOptions = (options: Options<MetaCodeAllData>) => queryOptions<MetaCodeAllResponse2, MetaCodeAllError, MetaCodeAllResponse2, ReturnType<typeof metaCodeAllQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaCodeAll({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaCodeAllQueryKey(options)
});

/**
 * 공통코드 초기화
 *
 * 공통코드가 추가된 경우 초기화 합니다
 */
export const commonCodeInitMutation = (options?: Partial<Options<CommonCodeInitData>>): UseMutationOptions<CommonCodeInitResponse, CommonCodeInitError, Options<CommonCodeInitData>> => {
    const mutationOptions: UseMutationOptions<CommonCodeInitResponse, CommonCodeInitError, Options<CommonCodeInitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commonCodeInit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkPlusSuccessQueryKey = (options: Options<CheckPlusSuccessData>) => createQueryKey('checkPlusSuccess', options);

/**
 * Nice 신용인증 성공시 이동될 URL
 */
export const checkPlusSuccessOptions = (options: Options<CheckPlusSuccessData>) => queryOptions<CheckPlusSuccessResponse, CheckPlusSuccessError, CheckPlusSuccessResponse, ReturnType<typeof checkPlusSuccessQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkPlusSuccess({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkPlusSuccessQueryKey(options)
});

export const getNonMemberSuggestPolicyListQueryKey = (options: Options<GetNonMemberSuggestPolicyListData>) => createQueryKey('getNonMemberSuggestPolicyList', options);

/**
 * 비회원 맞춤 정책 검색목록 조회
 */
export const getNonMemberSuggestPolicyListOptions = (options: Options<GetNonMemberSuggestPolicyListData>) => queryOptions<GetNonMemberSuggestPolicyListResponse, GetNonMemberSuggestPolicyListError, GetNonMemberSuggestPolicyListResponse, ReturnType<typeof getNonMemberSuggestPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getNonMemberSuggestPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getNonMemberSuggestPolicyListQueryKey(options)
});

export const findNonsanRouletteQueryKey = (options?: Options<FindNonsanRouletteData>) => createQueryKey('findNonsanRoulette', options);

/**
 * 룰렛 구성 조회
 *
 * 진행 중(ACTIVE) 룰렛 이벤트의 기간과 경품 등급 목록을 반환합니다. 진행 중인 이벤트가 없으면 30404. 등급별 잔여 수량은 노출하지 않으며, 휠 칸 배치는 FE 가 결정합니다.
 */
export const findNonsanRouletteOptions = (options?: Options<FindNonsanRouletteData>) => queryOptions<FindNonsanRouletteResponse, FindNonsanRouletteError, FindNonsanRouletteResponse, ReturnType<typeof findNonsanRouletteQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findNonsanRoulette({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findNonsanRouletteQueryKey(options)
});

export const getPointMarketProductListQueryKey = (options?: Options<GetPointMarketProductListData>) => createQueryKey('getPointMarketProductList', options);

/**
 * 상품 목록 조회
 */
export const getPointMarketProductListOptions = (options?: Options<GetPointMarketProductListData>) => queryOptions<GetPointMarketProductListResponse, GetPointMarketProductListError, GetPointMarketProductListResponse, ReturnType<typeof getPointMarketProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointMarketProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketProductListQueryKey(options)
});

export const getPointMarketProductListInfiniteQueryKey = (options?: Options<GetPointMarketProductListData>): QueryKey<Options<GetPointMarketProductListData>> => createQueryKey('getPointMarketProductList', options, true);

/**
 * 상품 목록 조회
 */
export const getPointMarketProductListInfiniteOptions = (options?: Options<GetPointMarketProductListData>) => {
    const opts = infiniteQueryOptions<GetPointMarketProductListResponse, GetPointMarketProductListError, InfiniteData<GetPointMarketProductListResponse>, QueryKey<Options<GetPointMarketProductListData>>, number | Pick<QueryKey<Options<GetPointMarketProductListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetPointMarketProductListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getPointMarketProductList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPointMarketProductListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getPointMarketProductListByBrandQueryKey = (options?: Options<GetPointMarketProductListByBrandData>) => createQueryKey('getPointMarketProductListByBrand', options);

/**
 * 브랜드별 상품 목록 조회 (페이징 없음)
 */
export const getPointMarketProductListByBrandOptions = (options?: Options<GetPointMarketProductListByBrandData>) => queryOptions<GetPointMarketProductListByBrandResponse, GetPointMarketProductListByBrandError, GetPointMarketProductListByBrandResponse, ReturnType<typeof getPointMarketProductListByBrandQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointMarketProductListByBrand({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketProductListByBrandQueryKey(options)
});

export const findDaouProductListQueryKey = (options?: Options<FindDaouProductListData>) => createQueryKey('findDaouProductList', options);

/**
 * 다우기술 전체 상품정보 조회
 *
 * 다우기술 운영 서버에서 전체 상품정보를 내려받아 DB 저장 없이 그대로 반환한다.
 */
export const findDaouProductListOptions = (options?: Options<FindDaouProductListData>) => queryOptions<FindDaouProductListResponse, FindDaouProductListError, FindDaouProductListResponse, ReturnType<typeof findDaouProductListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findDaouProductList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findDaouProductListQueryKey(options)
});

export const getPointMarketProductQueryKey = (options: Options<GetPointMarketProductData>) => createQueryKey('getPointMarketProduct', options);

/**
 * 상품 상세 조회(+ 지금 본 상품과 비슷한 상품 목록)
 */
export const getPointMarketProductOptions = (options: Options<GetPointMarketProductData>) => queryOptions<GetPointMarketProductResponse, GetPointMarketProductError, GetPointMarketProductResponse, ReturnType<typeof getPointMarketProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPointMarketProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPointMarketProductQueryKey(options)
});

/**
 * 상품 상세 조회 피드백(조회수 증가)
 */
export const feedbackPointMarketProductMutation = (options?: Partial<Options<FeedbackPointMarketProductData>>): UseMutationOptions<FeedbackPointMarketProductResponse, FeedbackPointMarketProductError, Options<FeedbackPointMarketProductData>> => {
    const mutationOptions: UseMutationOptions<FeedbackPointMarketProductResponse, FeedbackPointMarketProductError, Options<FeedbackPointMarketProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await feedbackPointMarketProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getListPolicyCaseCategoryQueryKey = (options?: Options<GetListPolicyCaseCategoryData>) => createQueryKey('getListPolicyCaseCategory', options);

/**
 * 내 상황에 맞는 정책 카테고리
 */
export const getListPolicyCaseCategoryOptions = (options?: Options<GetListPolicyCaseCategoryData>) => queryOptions<GetListPolicyCaseCategoryResponse, GetListPolicyCaseCategoryError, GetListPolicyCaseCategoryResponse, ReturnType<typeof getListPolicyCaseCategoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getListPolicyCaseCategory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getListPolicyCaseCategoryQueryKey(options)
});

export const getPolicyCodeGeocodingListQueryKey = (options?: Options<GetPolicyCodeGeocodingListData>) => createQueryKey('getPolicyCodeGeocodingList', options);

/**
 * 지역 좌표 목록 조회
 */
export const getPolicyCodeGeocodingListOptions = (options?: Options<GetPolicyCodeGeocodingListData>) => queryOptions<GetPolicyCodeGeocodingListResponse, GetPolicyCodeGeocodingListError, GetPolicyCodeGeocodingListResponse, ReturnType<typeof getPolicyCodeGeocodingListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPolicyCodeGeocodingList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPolicyCodeGeocodingListQueryKey(options)
});

export const getPolicyDictionaryListQueryKey = (options?: Options<GetPolicyDictionaryListData>) => createQueryKey('getPolicyDictionaryList', options);

/**
 * 정책 사전 목록 조회
 */
export const getPolicyDictionaryListOptions = (options?: Options<GetPolicyDictionaryListData>) => queryOptions<GetPolicyDictionaryListResponse, GetPolicyDictionaryListError, GetPolicyDictionaryListResponse, ReturnType<typeof getPolicyDictionaryListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPolicyDictionaryList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPolicyDictionaryListQueryKey(options)
});

export const metaPolicyFeedbackQueryKey = (options: Options<MetaPolicyFeedbackData>) => createQueryKey('metaPolicyFeedback', options);

/**
 * 비로그인 멤버 정책 좋아요&스크랩 정보 조회
 */
export const metaPolicyFeedbackOptions = (options: Options<MetaPolicyFeedbackData>) => queryOptions<MetaPolicyFeedbackResponse, MetaPolicyFeedbackError, MetaPolicyFeedbackResponse, ReturnType<typeof metaPolicyFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaPolicyFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaPolicyFeedbackQueryKey(options)
});

export const popularPolicyListQueryKey = (options?: Options<PopularPolicyListData>) => createQueryKey('popularPolicyList', options);

/**
 * 비회원 인기정책 조회
 */
export const popularPolicyListOptions = (options?: Options<PopularPolicyListData>) => queryOptions<PopularPolicyListResponse, PopularPolicyListError, PopularPolicyListResponse, ReturnType<typeof popularPolicyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await popularPolicyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: popularPolicyListQueryKey(options)
});

export const metaPolicyQueryKey = (options: Options<MetaPolicyData>) => createQueryKey('metaPolicy', options);

/**
 * 비회원 정책 상세 조회
 */
export const metaPolicyOptions = (options: Options<MetaPolicyData>) => queryOptions<MetaPolicyResponse, MetaPolicyError, MetaPolicyResponse, ReturnType<typeof metaPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await metaPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: metaPolicyQueryKey(options)
});

/**
 * 정책 AI 정보 업데이트
 */
export const updatePolicyAiInfoMutation = (options?: Partial<Options<UpdatePolicyAiInfoData>>): UseMutationOptions<UpdatePolicyAiInfoResponse, UpdatePolicyAiInfoError, Options<UpdatePolicyAiInfoData>> => {
    const mutationOptions: UseMutationOptions<UpdatePolicyAiInfoResponse, UpdatePolicyAiInfoError, Options<UpdatePolicyAiInfoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePolicyAiInfo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const findBestContentsQueryKey = (options: Options<FindBestContentsData>) => createQueryKey('findBestContents', options);

/**
 * 정책소식 검색
 */
export const findBestContentsOptions = (options: Options<FindBestContentsData>) => queryOptions<FindBestContentsResponse, FindBestContentsError, FindBestContentsResponse, ReturnType<typeof findBestContentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findBestContents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findBestContentsQueryKey(options)
});

export const findBestContentsInfiniteQueryKey = (options: Options<FindBestContentsData>): QueryKey<Options<FindBestContentsData>> => createQueryKey('findBestContents', options, true);

/**
 * 정책소식 검색
 */
export const findBestContentsInfiniteOptions = (options: Options<FindBestContentsData>) => {
    const opts = infiniteQueryOptions<FindBestContentsResponse, FindBestContentsError, InfiniteData<FindBestContentsResponse>, QueryKey<Options<FindBestContentsData>>, number | Pick<QueryKey<Options<FindBestContentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindBestContentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findBestContents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findBestContentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findDonationBusinessesQueryKey = (options?: Options<FindDonationBusinessesData>) => createQueryKey('findDonationBusinesses', options);

/**
 * 지정기부사업 검색
 */
export const findDonationBusinessesOptions = (options?: Options<FindDonationBusinessesData>) => queryOptions<FindDonationBusinessesResponse, FindDonationBusinessesError, FindDonationBusinessesResponse, ReturnType<typeof findDonationBusinessesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findDonationBusinesses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findDonationBusinessesQueryKey(options)
});

export const findDonationBusinessesInfiniteQueryKey = (options?: Options<FindDonationBusinessesData>): QueryKey<Options<FindDonationBusinessesData>> => createQueryKey('findDonationBusinesses', options, true);

/**
 * 지정기부사업 검색
 */
export const findDonationBusinessesInfiniteOptions = (options?: Options<FindDonationBusinessesData>) => {
    const opts = infiniteQueryOptions<FindDonationBusinessesResponse, FindDonationBusinessesError, InfiniteData<FindDonationBusinessesResponse>, QueryKey<Options<FindDonationBusinessesData>>, number | Pick<QueryKey<Options<FindDonationBusinessesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindDonationBusinessesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findDonationBusinesses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findDonationBusinessesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findGiftProductsQueryKey = (options?: Options<FindGiftProductsData>) => createQueryKey('findGiftProducts', options);

/**
 * 답례품 검색
 */
export const findGiftProductsOptions = (options?: Options<FindGiftProductsData>) => queryOptions<FindGiftProductsResponse, FindGiftProductsError, FindGiftProductsResponse, ReturnType<typeof findGiftProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findGiftProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findGiftProductsQueryKey(options)
});

export const findGiftProductsInfiniteQueryKey = (options?: Options<FindGiftProductsData>): QueryKey<Options<FindGiftProductsData>> => createQueryKey('findGiftProducts', options, true);

/**
 * 답례품 검색
 */
export const findGiftProductsInfiniteOptions = (options?: Options<FindGiftProductsData>) => {
    const opts = infiniteQueryOptions<FindGiftProductsResponse, FindGiftProductsError, InfiniteData<FindGiftProductsResponse>, QueryKey<Options<FindGiftProductsData>>, number | Pick<QueryKey<Options<FindGiftProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindGiftProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findGiftProducts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findGiftProductsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findHometownNewsQueryKey = (options?: Options<FindHometownNewsData>) => createQueryKey('findHometownNews', options);

/**
 * 동네소식 검색
 */
export const findHometownNewsOptions = (options?: Options<FindHometownNewsData>) => queryOptions<FindHometownNewsResponse, FindHometownNewsError, FindHometownNewsResponse, ReturnType<typeof findHometownNewsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findHometownNews({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findHometownNewsQueryKey(options)
});

export const findHometownNewsInfiniteQueryKey = (options?: Options<FindHometownNewsData>): QueryKey<Options<FindHometownNewsData>> => createQueryKey('findHometownNews', options, true);

/**
 * 동네소식 검색
 */
export const findHometownNewsInfiniteOptions = (options?: Options<FindHometownNewsData>) => {
    const opts = infiniteQueryOptions<FindHometownNewsResponse, FindHometownNewsError, InfiniteData<FindHometownNewsResponse>, QueryKey<Options<FindHometownNewsData>>, number | Pick<QueryKey<Options<FindHometownNewsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindHometownNewsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findHometownNews({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findHometownNewsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findIntegratedQueryKey = (options?: Options<FindIntegratedData>) => createQueryKey('findIntegrated', options);

/**
 * 통합검색
 *
 * 검색어로 정책·동네소식·정책소식·답례품·지정기부사업·웰마켓을 병렬 검색해 카테고리별 블록으로 종합 반환한다. 축제는 festivalSubRegionCode+festivalRadius가 있을 때만 포함한다. 각 블록은 기존 카테고리 응답과 동일하다.
 */
export const findIntegratedOptions = (options?: Options<FindIntegratedData>) => queryOptions<FindIntegratedResponse, FindIntegratedError, FindIntegratedResponse, ReturnType<typeof findIntegratedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findIntegrated({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findIntegratedQueryKey(options)
});

export const findIntegratedInfiniteQueryKey = (options?: Options<FindIntegratedData>): QueryKey<Options<FindIntegratedData>> => createQueryKey('findIntegrated', options, true);

/**
 * 통합검색
 *
 * 검색어로 정책·동네소식·정책소식·답례품·지정기부사업·웰마켓을 병렬 검색해 카테고리별 블록으로 종합 반환한다. 축제는 festivalSubRegionCode+festivalRadius가 있을 때만 포함한다. 각 블록은 기존 카테고리 응답과 동일하다.
 */
export const findIntegratedInfiniteOptions = (options?: Options<FindIntegratedData>) => {
    const opts = infiniteQueryOptions<FindIntegratedResponse, FindIntegratedError, InfiniteData<FindIntegratedResponse>, QueryKey<Options<FindIntegratedData>>, number | Pick<QueryKey<Options<FindIntegratedData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindIntegratedData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findIntegrated({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findIntegratedInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findLocalMarketProductsQueryKey = (options?: Options<FindLocalMarketProductsData>) => createQueryKey('findLocalMarketProducts', options);

/**
 * 웰마켓 검색
 */
export const findLocalMarketProductsOptions = (options?: Options<FindLocalMarketProductsData>) => queryOptions<FindLocalMarketProductsResponse, FindLocalMarketProductsError, FindLocalMarketProductsResponse, ReturnType<typeof findLocalMarketProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findLocalMarketProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findLocalMarketProductsQueryKey(options)
});

export const findLocalMarketProductsInfiniteQueryKey = (options?: Options<FindLocalMarketProductsData>): QueryKey<Options<FindLocalMarketProductsData>> => createQueryKey('findLocalMarketProducts', options, true);

/**
 * 웰마켓 검색
 */
export const findLocalMarketProductsInfiniteOptions = (options?: Options<FindLocalMarketProductsData>) => {
    const opts = infiniteQueryOptions<FindLocalMarketProductsResponse, FindLocalMarketProductsError, InfiniteData<FindLocalMarketProductsResponse>, QueryKey<Options<FindLocalMarketProductsData>>, number | Pick<QueryKey<Options<FindLocalMarketProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindLocalMarketProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findLocalMarketProducts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findLocalMarketProductsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findPoliciesQueryKey = (options?: Options<FindPoliciesData>) => createQueryKey('findPolicies', options);

/**
 * 정책 검색
 */
export const findPoliciesOptions = (options?: Options<FindPoliciesData>) => queryOptions<FindPoliciesResponse, FindPoliciesError, FindPoliciesResponse, ReturnType<typeof findPoliciesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findPolicies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findPoliciesQueryKey(options)
});

export const findPoliciesInfiniteQueryKey = (options?: Options<FindPoliciesData>): QueryKey<Options<FindPoliciesData>> => createQueryKey('findPolicies', options, true);

/**
 * 정책 검색
 */
export const findPoliciesInfiniteOptions = (options?: Options<FindPoliciesData>) => {
    const opts = infiniteQueryOptions<FindPoliciesResponse, FindPoliciesError, InfiniteData<FindPoliciesResponse>, QueryKey<Options<FindPoliciesData>>, number | Pick<QueryKey<Options<FindPoliciesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindPoliciesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findPolicies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findPoliciesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const findQueryAgeCodeQueryKey = (options?: Options<FindQueryAgeCodeData>) => createQueryKey('findQueryAgeCode', options);

/**
 * 정책 검색 - 연령
 */
export const findQueryAgeCodeOptions = (options?: Options<FindQueryAgeCodeData>) => queryOptions<FindQueryAgeCodeResponse, FindQueryAgeCodeError, FindQueryAgeCodeResponse, ReturnType<typeof findQueryAgeCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryAgeCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryAgeCodeQueryKey(options)
});

export const findQueryJobCodeQueryKey = (options?: Options<FindQueryJobCodeData>) => createQueryKey('findQueryJobCode', options);

/**
 * 정책 검색 - 직업
 */
export const findQueryJobCodeOptions = (options?: Options<FindQueryJobCodeData>) => queryOptions<FindQueryJobCodeResponse, FindQueryJobCodeError, FindQueryJobCodeResponse, ReturnType<typeof findQueryJobCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryJobCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryJobCodeQueryKey(options)
});

export const findQueryProvisionCodeQueryKey = (options?: Options<FindQueryProvisionCodeData>) => createQueryKey('findQueryProvisionCode', options);

/**
 * 정책 검색, 정책 활용 가이드 - 지원형태
 */
export const findQueryProvisionCodeOptions = (options?: Options<FindQueryProvisionCodeData>) => queryOptions<FindQueryProvisionCodeResponse, FindQueryProvisionCodeError, FindQueryProvisionCodeResponse, ReturnType<typeof findQueryProvisionCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryProvisionCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryProvisionCodeQueryKey(options)
});

export const findQueryTargetCodeQueryKey = (options?: Options<FindQueryTargetCodeData>) => createQueryKey('findQueryTargetCode', options);

/**
 * 정책 검색 - 대상
 */
export const findQueryTargetCodeOptions = (options?: Options<FindQueryTargetCodeData>) => queryOptions<FindQueryTargetCodeResponse, FindQueryTargetCodeError, FindQueryTargetCodeResponse, ReturnType<typeof findQueryTargetCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findQueryTargetCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findQueryTargetCodeQueryKey(options)
});

export const findTourFestivalsQueryKey = (options: Options<FindTourFestivalsData>) => createQueryKey('findTourFestivals', options);

/**
 * 축제 위치 기반 목록
 *
 * subRegionCode 좌표 기준 radius(미터) 내 축제를 거리 ASC로 정렬해 반환한다. 응답은 distance(미터)를 포함한다.
 */
export const findTourFestivalsOptions = (options: Options<FindTourFestivalsData>) => queryOptions<FindTourFestivalsResponse, FindTourFestivalsError, FindTourFestivalsResponse, ReturnType<typeof findTourFestivalsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourFestivals({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourFestivalsQueryKey(options)
});

export const findTourFestivalsInfiniteQueryKey = (options: Options<FindTourFestivalsData>): QueryKey<Options<FindTourFestivalsData>> => createQueryKey('findTourFestivals', options, true);

/**
 * 축제 위치 기반 목록
 *
 * subRegionCode 좌표 기준 radius(미터) 내 축제를 거리 ASC로 정렬해 반환한다. 응답은 distance(미터)를 포함한다.
 */
export const findTourFestivalsInfiniteOptions = (options: Options<FindTourFestivalsData>) => {
    const opts = infiniteQueryOptions<FindTourFestivalsResponse, FindTourFestivalsError, InfiniteData<FindTourFestivalsResponse>, QueryKey<Options<FindTourFestivalsData>>, number | Pick<QueryKey<Options<FindTourFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<FindTourFestivalsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await findTourFestivals({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: findTourFestivalsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * 파일 삭제
 */
export const fileDeleteMutation = (options?: Partial<Options<FileDeleteData>>): UseMutationOptions<FileDeleteResponse, FileDeleteError, Options<FileDeleteData>> => {
    const mutationOptions: UseMutationOptions<FileDeleteResponse, FileDeleteError, Options<FileDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 파일 업로드
 */
export const fileUploadMutation = (options?: Partial<Options<FileUploadData>>): UseMutationOptions<FileUploadResponse, FileUploadError, Options<FileUploadData>> => {
    const mutationOptions: UseMutationOptions<FileUploadResponse, FileUploadError, Options<FileUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await fileUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 파일 템프 저장 여부 상태 수정
 */
export const updateFileTempSaveYnMutation = (options?: Partial<Options<UpdateFileTempSaveYnData>>): UseMutationOptions<UpdateFileTempSaveYnResponse, UpdateFileTempSaveYnError, Options<UpdateFileTempSaveYnData>> => {
    const mutationOptions: UseMutationOptions<UpdateFileTempSaveYnResponse, UpdateFileTempSaveYnError, Options<UpdateFileTempSaveYnData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFileTempSaveYn({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fileDecryptionDownloadQueryKey = (options: Options<FileDecryptionDownloadData>) => createQueryKey('fileDecryptionDownload', options);

/**
 * 비회원 파일 복호화 다운로드
 */
export const fileDecryptionDownloadOptions = (options: Options<FileDecryptionDownloadData>) => queryOptions<FileDecryptionDownloadResponse, FileDecryptionDownloadError, FileDecryptionDownloadResponse, ReturnType<typeof fileDecryptionDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await fileDecryptionDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: fileDecryptionDownloadQueryKey(options)
});

export const termQueryKey = (options: Options<TermData>) => createQueryKey('term', options);

/**
 * 약관을 조회합니다.
 *
 * 약관 조회
 */
export const termOptions = (options: Options<TermData>) => queryOptions<TermResponse, TermError, TermResponse, ReturnType<typeof termQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await term({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: termQueryKey(options)
});

export const findTourFeedbackQueryKey = (options: Options<FindTourFeedbackData>) => createQueryKey('findTourFeedback', options);

/**
 * 투어 조회수/스크랩 정보 조회 (비로그인 허용)
 *
 * Tour 의 조회수/스크랩 정보를 조회한다.
 */
export const findTourFeedbackOptions = (options: Options<FindTourFeedbackData>) => queryOptions<FindTourFeedbackResponse, FindTourFeedbackError, FindTourFeedbackResponse, ReturnType<typeof findTourFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourFeedbackQueryKey(options)
});

export const findTourDistanceQueryKey = (options: Options<FindTourDistanceData>) => createQueryKey('findTourDistance', options);

/**
 * 투어 거리 조회 (비로그인 허용)
 *
 * subRegionCode 중심 좌표로부터 투어 point 까지의 거리(미터)를 계산한다. 중심 좌표 미존재 시 30404, 좌표 손상 시 30400, 투어 미존재/비공개 시 30404. point 없으면 distance=null.
 */
export const findTourDistanceOptions = (options: Options<FindTourDistanceData>) => queryOptions<FindTourDistanceResponse, FindTourDistanceError, FindTourDistanceResponse, ReturnType<typeof findTourDistanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTourDistance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTourDistanceQueryKey(options)
});

export const findTrendQueryKey = (options?: Options<FindTrendData>) => createQueryKey('findTrend', options);

/**
 * 인기검색어 순위 조회
 *
 * 최신 스냅샷의 인기검색어 순위(▲▼·급상승·신규 배지 포함)를 반환한다. 첫 배치 전에는 빈 목록이다.
 */
export const findTrendOptions = (options?: Options<FindTrendData>) => queryOptions<FindTrendResponse, FindTrendError, FindTrendResponse, ReturnType<typeof findTrendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await findTrend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: findTrendQueryKey(options)
});

export const getUrlMappingQueryKey = (options: Options<GetUrlMappingData>) => createQueryKey('getUrlMapping', options);

/**
 * URL 매핑 상세 조회
 *
 * URL 매핑 상세 조회
 */
export const getUrlMappingOptions = (options: Options<GetUrlMappingData>) => queryOptions<GetUrlMappingResponse, GetUrlMappingError, GetUrlMappingResponse, ReturnType<typeof getUrlMappingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUrlMapping({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUrlMappingQueryKey(options)
});

export const welloAppPushListQueryKey = (options: Options<WelloAppPushListData>) => createQueryKey('welloAppPushList', options);

/**
 * 웰로 앱 푸시 목록 조회
 */
export const welloAppPushListOptions = (options: Options<WelloAppPushListData>) => queryOptions<WelloAppPushListResponse, WelloAppPushListError, WelloAppPushListResponse, ReturnType<typeof welloAppPushListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloAppPushList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloAppPushListQueryKey(options)
});

export const welloAppPushListInfiniteQueryKey = (options: Options<WelloAppPushListData>): QueryKey<Options<WelloAppPushListData>> => createQueryKey('welloAppPushList', options, true);

/**
 * 웰로 앱 푸시 목록 조회
 */
export const welloAppPushListInfiniteOptions = (options: Options<WelloAppPushListData>) => {
    const opts = infiniteQueryOptions<WelloAppPushListResponse, WelloAppPushListError, InfiniteData<WelloAppPushListResponse>, QueryKey<Options<WelloAppPushListData>>, number | Pick<QueryKey<Options<WelloAppPushListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<WelloAppPushListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await welloAppPushList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: welloAppPushListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * 웰로 앱 푸시 읽음 처리
 */
export const updateWelloAppPushReadMutation = (options?: Partial<Options<UpdateWelloAppPushReadData>>): UseMutationOptions<UpdateWelloAppPushReadResponse, UpdateWelloAppPushReadError, Options<UpdateWelloAppPushReadData>> => {
    const mutationOptions: UseMutationOptions<UpdateWelloAppPushReadResponse, UpdateWelloAppPushReadError, Options<UpdateWelloAppPushReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWelloAppPushRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const newWelloAppPushCntQueryKey = (options: Options<NewWelloAppPushCntData>) => createQueryKey('newWelloAppPushCnt', options);

/**
 * 웰로 앱 푸시 알림 건수 조회
 */
export const newWelloAppPushCntOptions = (options: Options<NewWelloAppPushCntData>) => queryOptions<NewWelloAppPushCntResponse, NewWelloAppPushCntError, NewWelloAppPushCntResponse, ReturnType<typeof newWelloAppPushCntQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await newWelloAppPushCnt({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: newWelloAppPushCntQueryKey(options)
});

/**
 * 웰로 앱 푸시(외부) 요청
 */
export const sendExtAppPushMutation = (options?: Partial<Options<SendExtAppPushData>>): UseMutationOptions<SendExtAppPushResponse, SendExtAppPushError, Options<SendExtAppPushData>> => {
    const mutationOptions: UseMutationOptions<SendExtAppPushResponse, SendExtAppPushError, Options<SendExtAppPushData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendExtAppPush({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 웰로 앱 푸시 트래킹&읽음 처리
 */
export const updateWelloAppPushRead1Mutation = (options?: Partial<Options<UpdateWelloAppPushRead1Data>>): UseMutationOptions<UpdateWelloAppPushRead1Response, UpdateWelloAppPushRead1Error, Options<UpdateWelloAppPushRead1Data>> => {
    const mutationOptions: UseMutationOptions<UpdateWelloAppPushRead1Response, UpdateWelloAppPushRead1Error, Options<UpdateWelloAppPushRead1Data>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateWelloAppPushRead1({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMetaPolicyCommentListQueryKey = (options: Options<GetMetaPolicyCommentListData>) => createQueryKey('getMetaPolicyCommentList', options);

/**
 * 댓글 목록 조회
 */
export const getMetaPolicyCommentListOptions = (options: Options<GetMetaPolicyCommentListData>) => queryOptions<GetMetaPolicyCommentListResponse, GetMetaPolicyCommentListError, GetMetaPolicyCommentListResponse, ReturnType<typeof getMetaPolicyCommentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetaPolicyCommentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetaPolicyCommentListQueryKey(options)
});

export const getMetaPolicyCommentListInfiniteQueryKey = (options: Options<GetMetaPolicyCommentListData>): QueryKey<Options<GetMetaPolicyCommentListData>> => createQueryKey('getMetaPolicyCommentList', options, true);

/**
 * 댓글 목록 조회
 */
export const getMetaPolicyCommentListInfiniteOptions = (options: Options<GetMetaPolicyCommentListData>) => {
    const opts = infiniteQueryOptions<GetMetaPolicyCommentListResponse, GetMetaPolicyCommentListError, InfiniteData<GetMetaPolicyCommentListResponse>, QueryKey<Options<GetMetaPolicyCommentListData>>, number | Pick<QueryKey<Options<GetMetaPolicyCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetMetaPolicyCommentListData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getMetaPolicyCommentList({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMetaPolicyCommentListInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getLiveWelloCommentListQueryKey = (options?: Options<GetLiveWelloCommentListData>) => createQueryKey('getLiveWelloCommentList', options);

/**
 * 웰로 실시간 정책 의견
 *
 * @deprecated
 */
export const getLiveWelloCommentListOptions = (options?: Options<GetLiveWelloCommentListData>) => queryOptions<GetLiveWelloCommentListResponse, GetLiveWelloCommentListError, GetLiveWelloCommentListResponse, ReturnType<typeof getLiveWelloCommentListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLiveWelloCommentList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLiveWelloCommentListQueryKey(options)
});

export const getMetaPolicyCommentList1QueryKey = (options: Options<GetMetaPolicyCommentList1Data>) => createQueryKey('getMetaPolicyCommentList1', options);

/**
 * 댓글 상세 조회
 */
export const getMetaPolicyCommentList1Options = (options: Options<GetMetaPolicyCommentList1Data>) => queryOptions<GetMetaPolicyCommentList1Response, GetMetaPolicyCommentList1Error, GetMetaPolicyCommentList1Response, ReturnType<typeof getMetaPolicyCommentList1QueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMetaPolicyCommentList1({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMetaPolicyCommentList1QueryKey(options)
});

/**
 * 웰로 디바이스 정보 저장
 */
export const saveAllowsWelloDeviceInfoMutation = (options?: Partial<Options<SaveAllowsWelloDeviceInfoData>>): UseMutationOptions<SaveAllowsWelloDeviceInfoResponse, SaveAllowsWelloDeviceInfoError, Options<SaveAllowsWelloDeviceInfoData>> => {
    const mutationOptions: UseMutationOptions<SaveAllowsWelloDeviceInfoResponse, SaveAllowsWelloDeviceInfoError, Options<SaveAllowsWelloDeviceInfoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveAllowsWelloDeviceInfo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const messageReceiveQueryKey = (options: Options<MessageReceiveData>) => createQueryKey('messageReceive', options);

/**
 * 알림수신여부 조회
 *
 * 알림수신 여부를 조회합니다
 */
export const messageReceiveOptions = (options: Options<MessageReceiveData>) => queryOptions<MessageReceiveResponse, MessageReceiveError, MessageReceiveResponse, ReturnType<typeof messageReceiveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await messageReceive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: messageReceiveQueryKey(options)
});

/**
 * 알림수신여부 수정
 *
 * 알림수신 여부를 수정합니다
 */
export const updateMessageReceiveMutation = (options?: Partial<Options<UpdateMessageReceiveData>>): UseMutationOptions<UpdateMessageReceiveResponse, UpdateMessageReceiveError, Options<UpdateMessageReceiveData>> => {
    const mutationOptions: UseMutationOptions<UpdateMessageReceiveResponse, UpdateMessageReceiveError, Options<UpdateMessageReceiveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMessageReceive({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 비회원 대상지역 정보 저장
 */
export const saveWelloNonmemberRegionMutation = (options?: Partial<Options<SaveWelloNonmemberRegionData>>): UseMutationOptions<SaveWelloNonmemberRegionResponse, SaveWelloNonmemberRegionError, Options<SaveWelloNonmemberRegionData>> => {
    const mutationOptions: UseMutationOptions<SaveWelloNonmemberRegionResponse, SaveWelloNonmemberRegionError, Options<SaveWelloNonmemberRegionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveWelloNonmemberRegion({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const welloPolicyCodeListQueryKey = (options: Options<WelloPolicyCodeListData>) => createQueryKey('welloPolicyCodeList', options);

/**
 * 웰로 정책 코드 목록
 */
export const welloPolicyCodeListOptions = (options: Options<WelloPolicyCodeListData>) => queryOptions<WelloPolicyCodeListResponse, WelloPolicyCodeListError, WelloPolicyCodeListResponse, ReturnType<typeof welloPolicyCodeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPolicyCodeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPolicyCodeListQueryKey(options)
});

export const welloPolicyCodeAllListQueryKey = (options?: Options<WelloPolicyCodeAllListData>) => createQueryKey('welloPolicyCodeAllList', options);

/**
 * 웰로 정책 코드 전체 목록
 */
export const welloPolicyCodeAllListOptions = (options?: Options<WelloPolicyCodeAllListData>) => queryOptions<WelloPolicyCodeAllListResponse, WelloPolicyCodeAllListError, WelloPolicyCodeAllListResponse, ReturnType<typeof welloPolicyCodeAllListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPolicyCodeAllList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPolicyCodeAllListQueryKey(options)
});

export const welloPolicyCodeBabyListQueryKey = (options?: Options<WelloPolicyCodeBabyListData>) => createQueryKey('welloPolicyCodeBabyList', options);

/**
 * 웰로 정책 코드 육아생활 목록
 */
export const welloPolicyCodeBabyListOptions = (options?: Options<WelloPolicyCodeBabyListData>) => queryOptions<WelloPolicyCodeBabyListResponse, WelloPolicyCodeBabyListError, WelloPolicyCodeBabyListResponse, ReturnType<typeof welloPolicyCodeBabyListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await welloPolicyCodeBabyList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: welloPolicyCodeBabyListQueryKey(options)
});

export const kbWelloPolicyCodeAllListQueryKey = (options?: Options<KbWelloPolicyCodeAllListData>) => createQueryKey('kbWelloPolicyCodeAllList', options);

/**
 * KB 정책 코드 목록
 */
export const kbWelloPolicyCodeAllListOptions = (options?: Options<KbWelloPolicyCodeAllListData>) => queryOptions<KbWelloPolicyCodeAllListResponse, KbWelloPolicyCodeAllListError, KbWelloPolicyCodeAllListResponse, ReturnType<typeof kbWelloPolicyCodeAllListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await kbWelloPolicyCodeAllList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: kbWelloPolicyCodeAllListQueryKey(options)
});

export const reverseGeocodingQueryKey = (options: Options<ReverseGeocodingData>) => createQueryKey('reverseGeocoding', options);

/**
 * 경도&위도로 현재 위치의 지역정보 조회
 */
export const reverseGeocodingOptions = (options: Options<ReverseGeocodingData>) => queryOptions<ReverseGeocodingResponse2, ReverseGeocodingError, ReverseGeocodingResponse2, ReturnType<typeof reverseGeocodingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await reverseGeocoding({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: reverseGeocodingQueryKey(options)
});

export const getWelloQuickMenuListQueryKey = (options?: Options<GetWelloQuickMenuListData>) => createQueryKey('getWelloQuickMenuList', options);

/**
 * 웰로 퀵 메뉴 목록 조회
 *
 * 웰로 메인 상단 퀵 메뉴 목록을 조회합니다
 */
export const getWelloQuickMenuListOptions = (options?: Options<GetWelloQuickMenuListData>) => queryOptions<GetWelloQuickMenuListResponse, GetWelloQuickMenuListError, GetWelloQuickMenuListResponse, ReturnType<typeof getWelloQuickMenuListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWelloQuickMenuList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWelloQuickMenuListQueryKey(options)
});

/**
 * 웰로 비회원 트래킹 정보 저장
 */
export const saveWelloTrackingMutation = (options?: Partial<Options<SaveWelloTrackingData>>): UseMutationOptions<SaveWelloTrackingResponse, SaveWelloTrackingError, Options<SaveWelloTrackingData>> => {
    const mutationOptions: UseMutationOptions<SaveWelloTrackingResponse, SaveWelloTrackingError, Options<SaveWelloTrackingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveWelloTracking({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * V3 KB PAY 회원 웰로 로그인 — 토큰 발급(신규 회원은 자동 생성)
 */
export const loginWelloWithKbPayMutation = (options?: Partial<Options<LoginWelloWithKbPayData>>): UseMutationOptions<LoginWelloWithKbPayResponse, LoginWelloWithKbPayError, Options<LoginWelloWithKbPayData>> => {
    const mutationOptions: UseMutationOptions<LoginWelloWithKbPayResponse, LoginWelloWithKbPayError, Options<LoginWelloWithKbPayData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWelloWithKbPay({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getKbMemberLoginTypeListQueryKey = (options: Options<GetKbMemberLoginTypeListData>) => createQueryKey('getKbMemberLoginTypeList', options);

/**
 * V3 KB 연동 로그인 타입 목록
 */
export const getKbMemberLoginTypeListOptions = (options: Options<GetKbMemberLoginTypeListData>) => queryOptions<GetKbMemberLoginTypeListResponse, GetKbMemberLoginTypeListError, GetKbMemberLoginTypeListResponse, ReturnType<typeof getKbMemberLoginTypeListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getKbMemberLoginTypeList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getKbMemberLoginTypeListQueryKey(options)
});

/**
 * V3 SNS 로그인 — 기존 계정 토큰 발급, 신규는 가입 필요 신호(signupRequired)
 */
export const loginWelloSnsMemberMutation = (options?: Partial<Options<LoginWelloSnsMemberData>>): UseMutationOptions<LoginWelloSnsMemberResponse, LoginWelloSnsMemberError, Options<LoginWelloSnsMemberData>> => {
    const mutationOptions: UseMutationOptions<LoginWelloSnsMemberResponse, LoginWelloSnsMemberError, Options<LoginWelloSnsMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await loginWelloSnsMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const snsRefreshTokenQueryKey = (options: Options<SnsRefreshTokenData>) => createQueryKey('snsRefreshToken', options);

/**
 * V3 토큰 재발급
 */
export const snsRefreshTokenOptions = (options: Options<SnsRefreshTokenData>) => queryOptions<SnsRefreshTokenResponse, SnsRefreshTokenError, SnsRefreshTokenResponse, ReturnType<typeof snsRefreshTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await snsRefreshToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: snsRefreshTokenQueryKey(options)
});

/**
 * 가입 완료(complete) — 계정 이관 + 토큰 발급
 *
 * 약관 필수동의 완료 후 가입을 확정한다. 신규면 계정 생성 + 토큰 발급, 동일 CI 기존 계정이면 계정통합 필요를 반환한다.
 */
export const completeMutation = (options?: Partial<Options<CompleteData>>): UseMutationOptions<CompleteResponse, CompleteError, Options<CompleteData>> => {
    const mutationOptions: UseMutationOptions<CompleteResponse, CompleteError, Options<CompleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await complete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 가입 임시저장 생성/재사용(init)
 *
 * SNS 인증 후 가입 임시저장을 생성(또는 1시간 내 재사용)하고 참조키(UUID)를 반환한다.
 */
export const initMutation = (options?: Partial<Options<InitData>>): UseMutationOptions<InitResponse, InitError, Options<InitData>> => {
    const mutationOptions: UseMutationOptions<InitResponse, InitError, Options<InitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await init({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 가입 중 계정통합 — 기존 활성계정에 SNS 부착 + 로그인
 *
 * 가입 중 계정통합. <code>complete</code>가 동일인 활성계정 존재로 통합 필요를 반환한 뒤, 고객이 통합 팝업에서 동의하면 호출한다.
 * 기존(생존) 계정에 새 SNS 로그인수단을 부착하고 그 계정으로 로그인 토큰을 발급한다(신규 계정 미생성).
 */
export const integrateMutation = (options?: Partial<Options<IntegrateData>>): UseMutationOptions<IntegrateResponse, IntegrateError, Options<IntegrateData>> => {
    const mutationOptions: UseMutationOptions<IntegrateResponse, IntegrateError, Options<IntegrateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await integrate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 닉네임·약관동의 저장
 *
 * 닉네임·약관동의를 가입 임시저장에 반영한다(본인인증 전 단계).
 */
export const saveNicknameConsentMutation = (options?: Partial<Options<SaveNicknameConsentData>>): UseMutationOptions<SaveNicknameConsentResponse, SaveNicknameConsentError, Options<SaveNicknameConsentData>> => {
    const mutationOptions: UseMutationOptions<SaveNicknameConsentResponse, SaveNicknameConsentError, Options<SaveNicknameConsentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveNicknameConsent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * 가입 본인인증 반영(무세션)
 *
 * 무세션 본인인증(모바일OK/EZI-OK) 결과를 가입 임시저장에 반영한다.
 */
export const verifyMutation = (options?: Partial<Options<VerifyData>>): UseMutationOptions<VerifyResponse, VerifyError, Options<VerifyData>> => {
    const mutationOptions: UseMutationOptions<VerifyResponse, VerifyError, Options<VerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await verify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
